import "animate.css"
import React, { useEffect, useRef, useState } from "react"
import Marquee from "react-fast-marquee"
import Layout from "../components/layout"
import Seo from "../components/seo"
import * as allImages from "../utils/images"
import InvimaticLogo from "../../static/invimatic-social-icon.png"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward'
import arrowRight from "../images/icons/arrowRight.svg"
import chatIcon from "../images/icons/chatIcon.svg"
// client logos
import axolotl from "../images/clients/axolotl.svg"
import betterData from "../images/clients/betterData.svg"
import chnl from "../images/clients/chnl.svg"
import closify from "../images/clients/closify.svg"
import cybersentinel from "../images/clients/cybersentinel.svg"
import DCID from "../images/clients/dcid.svg"
import Demandshore from "../images/clients/demandshore.svg"
import discoInsight from "../images/clients/discoInsight.svg"
import elevatyr from "../images/clients/elevatyr.svg"
import englishExpress from "../images/clients/englishExpress.svg"
import Infopedia from "../images/clients/infopedia.svg"
import logapps from "../images/clients/logapps.svg"
import loops from "../images/clients/loops.svg"
import Maxxton from "../images/clients/maxxton.svg"
import mpharma from "../images/clients/mpharma.svg"
import Munivisor from "../images/clients/munivisor.svg"
import nesGlobal from "../images/clients/nesGlobal.svg"
import nfsTechnology from "../images/clients/nfsTechnology.svg"
import Peepsride from "../images/clients/peepsride.svg"
import Peoplefy from "../images/clients/peoplefy.svg"
import pulselabs from "../images/clients/pulselabs.svg"
import Eveentology from "../images/clients/Eveentology.svg"
import Redfish from "../images/clients/redfish.svg"
import saTechnologies from "../images/clients/saTechnologies.svg"
import shufflelab from "../images/clients/shufflelab.svg"
import windmill from "../images/clients/windmill.svg"
import xtaas from "../images/clients/xtaas.svg"
import Yugensys from "../images/clients/yugensys.svg"
import airrived from "../images/clients/Airrived.svg"
import blabber from "../images/clients/Blabber.svg"
import bonzai from "../images/clients/Bonzai.svg"
import maiLabs from "../images/clients/MAI-Labs.svg"
import revscale from "../images/clients/Revscale.svg"
import RVRPG from "../images/clients/RVRPG.svg"
import skillsBridge from "../images/clients/SkillsBridge.svg"
import youthPlanning from "../images/clients/Youth-Planning.svg"
import indialOil from "../images/clients/Indian-oil.svg"
import sharedChapter from "../images/clients/shared-chapter.svg"

import journey1 from "../images/journey/journey1.svg"
import journey2 from "../images/journey/journey2.svg"
import journey3 from "../images/journey/journey3.svg"
import journey4 from "../images/journey/journey4.svg"
import PES1 from "../images/whatWeDo/PES1.jpg"
import PES2 from "../images/whatWeDo/PES2.jpg"
import PES3 from "../images/whatWeDo/PES3.jpg"
import PES4 from "../images/whatWeDo/PES4.jpg"
import PES5 from "../images/whatWeDo/PES5.jpg"
import PESMobile1 from "../images/whatWeDo/PES-mobile-1.jpg"
import PESMobile2 from "../images/whatWeDo/PES-mobile-2.jpg"
import PESMobile3 from "../images/whatWeDo/PES-mobile-3.jpg"
import PESMobile4 from "../images/whatWeDo/PES-mobile-4.jpg"
import marketIntegration1 from "../images/whatWeDo/marketIntegration1.jpg"
import marketIntegration2 from "../images/whatWeDo/marketIntegration2.jpg"
import marketIntegration3 from "../images/whatWeDo/marketIntegration3.jpg"
import marketIntegrationMobile1 from "../images/whatWeDo/marketIntegrationMobile1.jpg"
import marketIntegrationMobile2 from "../images/whatWeDo/marketIntegrationMobile2.jpg"
import marketIntegrationMobile3 from "../images/whatWeDo/marketIntegrationMobile3.jpg"
import testimonial1 from "../images/whatWeDo/testimonial1.png"
import testimonial2Bg from "../images/whatWeDo/testimonial2.png"
import aaron from "../images/AaronDix.png"
import cleve from "../images/CliveVaz.png"
import Will from "../images/will_marling.jpg"
import continuousCompliance1 from "../images/whatWeDo/continuous-compliance1.jpg"
import continuousCompliance2 from "../images/whatWeDo/continuous-compliance2.jpg"
import continuousCompliance3 from "../images/whatWeDo/continuous-compliance3.jpg"
import continuousComplianceMobile1 from "../images/whatWeDo/continuous-compliance-mobile1.jpg"
import continuousComplianceMobile2 from "../images/whatWeDo/continuous-compliance-mobile2.jpg"
import continuousComplianceMobile3 from "../images/whatWeDo/continuous-compliance-mobile3.jpg"
import devesecopsSupport1 from "../images/whatWeDo/devesecops-support1.jpg"
import devesecopsSupport2 from "../images/whatWeDo/devesecops-support2.jpg"
import devesecopsSupport3 from "../images/whatWeDo/devesecops-support3.jpg"
import devesecopsSupport4 from "../images/whatWeDo/devesecops-support4.jpg"
import devesecopsSupportMobile1 from "../images/whatWeDo/devesecops-support-mobile1.jpg"
import devesecopsSupportMobile2 from "../images/whatWeDo/devesecops-support-mobile2.jpg"
import devesecopsSupportMobile3 from "../images/whatWeDo/devesecops-support-mobile3.jpg"
import devesecopsSupportMobile4 from "../images/whatWeDo/devesecops-support-mobile4.jpg"
import staffAugmentationHomeBanner from "../images/staff-augmentation-home-banner.jpg"

import invistat1 from "../images/whoWeAre/invistat1.png"
import planeIconMob from "../images/whoWeAre/planeIconMob.png"
import planeIcon from "../images/whoWeAre/planeIcon.svg"
import planeLine from "../images/whoWeAre/planeLine.svg"
import klarity from "../images/whoWeAre/klarity.png"
import theloops from "../images/whoWeAre/theloops.png"
import shuffleLabs from "../images/whoWeAre/shuffleLabs.png"
import casecard1 from "../images/newCaseStudies/casecard1.png"
import casecard2 from "../images/newCaseStudies/casecard2.png"
import casecard3 from "../images/newCaseStudies/casecard3.png"
import casecard4 from "../images/newCaseStudies/casecard4.jpg"
import casecard5 from "../images/newCaseStudies/casecard5.jpg"
import casecard6 from "../images/newCaseStudies/casecard6.jpg"
import casecard7 from "../images/newCaseStudies/casecard7.jpg"
import homepageBanner1 from "../images/home-banner1.jpg"
import homepageBanner2 from "../images/home-banner2.jpg"
import homepageBanner3 from "../images/home-banner3.jpg"
import homepageMobileBanner1 from "../images/home-banner1-mobile.jpg"
import homepageMobileBanner2 from "../images/home-banner2-mobile.jpg"
import homepageMobileBanner3 from "../images/home-banner3-mobile.jpg"
import semicircleimageDark from "../images/about/semicircleimageDark.png"

import Testimonial from "../components/testimonial"

// Import Swiper styles
import "swiper/css"
import "swiper/css/pagination"

import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  Divider,
  Grid,
  LinearProgress,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import Stack from "@mui/material/Stack"
import { Autoplay, Navigation, Pagination } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import Enquiry from "../components/enqiry"
import ContactDialog from "../components/contactDialog"
import styled from "@emotion/styled"

export const style = {
  error: {
    color: "#FF4128",
    display: "flex",
  },
  heading: {
    h3: {
      color: "#fff",
    },
    ".MuiDivider-root": {
      width: 64,
      height: 4,
      background: "#DC4C5A",
      mt: 1,
      // mb: 2
    },
    ".MuiButton-root": {
      py: "10px",
      px: 3,
      borderRadius: 6,
      backgroundColor: "#fff",
      fontSize: 14,
      fontWeight: 700,
      color: "#00111E",
      lineHeight: "normal",
    },
  },
  tabBox: {
    ".MuiTabs-flexContainer": {
      gap: 1,
    },
    ".MuiTabs-root": {
      maxWidth: "33%",
      flex: "0 0 33%",
    },
    ".MuiTab-root": {
      alignItems: "flex-start",
      minHeight: 38,
      py: 0,
      pl: 2.5,
      pr: 1,
      color: "#7e91a9",
      fontSize: 18,
      fontWeight: 400,
      textTransform: "capitalize",
      textAlign: "left",
      borderLeft: "3px solid rgba(255, 255, 255, 0.15)",

      "&.Mui-selected": {
        fontSize: 20,
        fontWeight: 700,
        color: "#000",
        textAlign: "left",
        borderLeft: "3px solid #D74763",
      },
    },
    ".MuiTabs-indicator": {
      left: 0,
      right: "unset",
      backgroundColor: "#D74763",
      width: 3,
    },
  },
  imgOverlay: {
    position: "absolute",
    bottom: 0,
    p: 6,
  },
  whatWeDoimgOverlay: {
    position: "absolute",
    transform: "translateY(-50%)",
  },
  industryCard: {
    width: "100%",
    maxWidth: 440,
  },

  chipLabel: {
    borderRadius: "50px",
    border: "1px solid #3ec042",
    padding: "8px 17px",
    mb: 2,
    fontSize: 12,
    fontWeight: 500,
    color: "#000",
    ".MuiChip-label": {
      p: 0,
    },
  },
  cardboxInner: {
    position: "absolute",
    bottom: "0px",
    padding: "20px",
    backgroundColor: "rgb(35 108 165 / 90%)",
    borderRadius: "10px",
    margin: "20px",
  },
  cardButton: {
    background:
      "linear-gradient(90deg, #eb5d41 8.97%, #db4b5b 48.17%, #cd3b72 90.69%) !important",
    border: "unset",
    borderRadius: "50px",
    display: "flex",
    gap: "8px",
    fontSize: "16px",
    fontWeight: 700,
    color: "#fff",
    padding: "4px 12px",
    width: "max-content",
    textTransform: "capitalize",
    "&:hover": {
      border: "unset",
      img: {
        animation: "slide2 1s ease-in-out",
      },
    },
  },
}

const CardContainer = styled(Box)({
  position: "relative",
  overflow: "hidden",
  borderRadius: "12px",
  cursor: "pointer",
  minHeight: "130px",
  transition: "all 0.3s ease",
  "&:hover img": {
    transform: "scale(1.1)", // Ensures image zooms on hover
  },
})

// Image style (only the image will zoom on hover)
const CardImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  transition: "transform 0.3s ease",
})

// Overlay that handles both default and hover states
const Overlay = styled(Box)(({ isHovered }: any) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: isHovered
    ? "linear-gradient(130deg, #256aa3 37.9%, rgba(37, 106, 163, 0.4) 92.57%)"
    : "rgba(0, 0, 0, 0.6)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  padding: "20px",
  color: "#fff",
  textAlign: "left",
  transition: "0s ease",
}))

// Description text style
const Description = styled(Typography)(() => ({
  opacity: 1,
  transition: "opacity 0.3s ease",
  marginTop: "8px",
}))

const OverlayButton = styled(Button)(() => ({
  opacity: 1,
  transition: "opacity 0.3s ease",
}))

const ImageCard = ({
  image,
  title,
  description,
  url,
  isHovered,
  buttonType,
  itemIndex,
}: any) => {
  return (
    <CardContainer>
      <CardImage src={image} alt={title}/>
      <Overlay isHovered={isHovered}>
        <Typography
          variant="h6"
          fontWeight={
            buttonType === "casestudy" || buttonType === "blog" ? 400 : 500
          }
          lineHeight="28px"
        >
          {title}
        </Typography>
        {description && (
          <Description variant="body2" >
            {description}
          </Description>
        )}
        <OverlayButton
          href={url}
          className="service-card-button"
          
          sx={{ left: itemIndex === 0 ? "2.5%" : "4.6%" }}
        >
          {buttonType === "page"
            ? "Know More"
            : buttonType === "casestudy"
            ? "Case Study"
            : "Blog"}
          <ArrowForwardIcon sx={{ fontSize: "16px", marginLeft: 1.2 }} />
        </OverlayButton>
      </Overlay>
    </CardContainer>
  )
}

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

const Homepage = (props: any) => {
  const whatWeDoServiceCardData = [
    {
      image: PES1,
      title: "UI/UX Design",
      description:
        "We design engaging, user-centric interfaces that elevate brand experiences through dynamic, scalable, and innovative web solutions.",
      url: "/ui-ux-design-solutions/",
      gridWidth: 8,
      buttonType: "page",
    },
    {
      image: PES2,
      title: "Mobile Application",
      description:
        "We develop innovative mobile applications for iOS and Android, delivering tailored, high-performance, and future-ready solutions.",
      url: "/ui-ux-design-solutions/",
      gridWidth: 4,
      buttonType: "page",
    },
    {
      image: PES3,
      title: "Web Application",
      description:
        "We deliver tailored web applications ensuring scalability, security, seamless integrations, and exceptional user experiences.",
      url: "/saas-application/",
      gridWidth: 4,
      buttonType: "page",
    },
    {
      image: PES4,
      title: "Quality Assurance",
      description:
        "We ensure flawless software performance through rigorous manual and automated QA testing, delivering exceptional user experiences and reliable solutions.",
      url: "/quality-assurance-solutions/",
      gridWidth: 4,
      buttonType: "page",
    },
    {
      image: PES5,
      title: "Captivate Your Users: Top UI/UX Design Trends for 2024",
      description: "",
      url: "/captivate-your-users-top-uiux-design-trends-for-2024/",
      gridWidth: 4,
      buttonType: "blog",
    },
  ]

  const whatWeDoDevsecopsCardData = [
    {
      image: devesecopsSupport1,
      title: "DevSecOps",
      description:
        "Invimatic’s DevSecOps services integrate security throughout your development process, ensuring full protection while maintaining operational efficiency. We improve software reliability and accelerate secure deployments for your SaaS business.",
      url: "/devsecops/",
      gridWidth: 8,
      buttonType: "page",
    },
    {
      image: devesecopsSupport2,
      title: "24/7 Support",
      description:
        "With our 24/7 support, get seamless platform performance and quick issue resolution. Our dedicated team ensures your SaaS business operates smoothly, allowing you to focus on growth and innovation.",
      url: "/24-7-saas-support-system/",
      gridWidth: 4,
      buttonType: "page",
    },
    {
      image: devesecopsSupport3,
      title: "DevSecOps Transformation for Faster, Secure Software Delivery",
      url: "/devsecops-transform/",
      gridWidth: 4,
      buttonType: "casestudy",
    },
    {
      image: devesecopsSupport4,
      title: "Essential DevSecOps Tools for Team Success",
      url: "/blog/devops-automation-tools/",
      gridWidth: 4,
      buttonType: "Blog",
    },
  ]

  const whatWeDoMobileData = [
    {
      title: "Product Engineering Services",
      subTitle: "Launch with Confidence",
      description:
        "At the MVP stage, speed and precision are imperative. Invimatic’s product engineering services help you bring your vision to life quickly, with a focus on scalability from day one. Our teams collaborate closely with you to validate your product idea, design a robust architecture, and develop a working prototype that not only meets your immediate goals but is designed to scale as your user base grows.",
      serviceCardData: [
        {
          title: "UI/UX Design",
          url: "/ui-ux-design-solutions/",
          image: PESMobile1,
          buttonName: "Know More",
        },
        {
          title: "Mobile Application",
          url: "/solution-mobile-application/",
          image: PESMobile2,
          buttonName: "Know More",
        },
        {
          title: "Web Application",
          url: "/saas-application/",
          image: PESMobile3,
          buttonName: "Know More",
        },
        {
          title: "Quality Assurance",
          url: "/quality-assurance-solutions/",
          image: PESMobile4,
          buttonName: "Know More",
        },
      ],
    },
    {
      title: "Marketplace Integrations",
      subTitle: "Seamless Integrations to Boost Reach",
      description:
        "When it’s time to scale up and acquire customers, seamless integrations and marketplace plugins are essential. Invimatic helps your SaaS platform integrate with popular third-party tools and services, providing your customers with the flexibility they demand. We enable smooth connectivity with other systems and offer custom plugins to help you expand your product’s reach, ensuring that your platform fits effortlessly into your customers' existing workflows.",
      serviceCardData: [
        {
          title: "Marketplace Integrations",
          url: "/saas-integration-platform/",
          image: marketIntegrationMobile1,
          buttonName: "Know More",
        },
        {
          title: "Streamlining Data - Salesforce and HubSpot Integration",
          url: "/streamlining-data-salesforce/",
          image: marketIntegrationMobile2,
          buttonName: "casestudy",
        },
        {
          title: "Third Party integrations to enrich your app development!",
          url: "/blog/integration/third-party-integrations-to-enrich-your-app-development/",
          image: marketIntegrationMobile3,
          buttonName: "Blog",
        },
      ],
    },
    {
      title: "Continuous Compliance",
      subTitle: "Protect Your Growth with Security and Compliance",
      description:
        "As your platform grows, customer retention becomes a top priority, and security is paramount. Invimatic provides advanced security solutions, including continuous compliance services such as SOC 2. We ensure your SaaS platform remains compliant with the latest security standards, building trust with your customers and protecting your business from vulnerabilities. Invimatic incorporates security at every step, and helps you safeguard your growth and strengthen customer loyalty.",
      serviceCardData: [
        {
          title: "Continuous Compliance",
          url: "/soc-2-compliance-saas-solutions/",
          image: continuousComplianceMobile1,
          buttonName: "Know More",
        },
        {
          title: "SOC 2 Compliance for a Leading SaaS Company",
          url: "/soc-2-compliance-saas-provider/",
          image: continuousComplianceMobile3,
          buttonName: "casestudy",
        },
        {
          title: "SaaS applications on Soc2 compliance",
          url: "/saas-applications-on-soc2-compliance/",
          image: continuousComplianceMobile2,
          buttonName: "Blog",
        },
      ],
    },
    {
      title: "DevSecOps and Support",
      subTitle: "Long-Term Stability and Support",
      description:
        "Sustainability is the key to long-term SaaS success. Invimatic offers comprehensive DevSecOps services, integrating security seamlessly into your development and operations processes. Our 24/7 support services ensure your platform runs smoothly at all times, giving you peace of mind. Whether it’s maintaining uptime, addressing technical issues, or continuously improving your infrastructure, we’re here to help you build a sustainable, future-proof SaaS product.",
      serviceCardData: [
        {
          title: "DevSecOps",
          url: "/devsecops/",
          image: devesecopsSupportMobile1,
          buttonName: "Know More",
        },
        {
          title: "24/7 Support",
          url: "/24-7-saas-support-system/",
          image: devesecopsSupportMobile2,
          buttonName: "Know More",
        },
        {
          title:
            "DevSecOps Transformation for Faster, Secure Software Delivery",
          url: "/devsecops-transform/",
          image: devesecopsSupportMobile3,
          buttonName: "casestudy",
        },
        {
          title: "Essential DevSecOps Tools for Team Success",
          url: "/blog/devops-automation-tools/",
          image: devesecopsSupportMobile4,
          buttonName: "Blog",
        },
      ],
    },
  ]

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const isTablet = useMediaQuery(theme.breakpoints.up("md"))
  const [cardHover1, setCardHover1] = React.useState(false)
  const [cardHover2, setCardHover2] = React.useState(false)
  const [hoveredIndex, setHoveredIndex] = useState<any>(null)

  //Saas Journey
  const stages = [
    { title: 'Product Market Fit', content: 'In the Product Market Fit phase, we help with rapid <strong>MVP development</strong> with scalable architectures to bring your product to life.', icon: journey1},
    { title: 'Customer Acquisition', content: 'Moving into the Customer Acquisition stage, our <strong>seamless integrations and marketplace plugins</strong> help you reach new users and expand your market presence.', icon: journey2},
    { title: 'Growth And Retention', content: 'For Growth and Retention, we ensure <strong>SOC 2 compliance</strong> with strong DevSecOps practices, building trust and safeguarding your platform.', icon: journey3 },
    { title: 'Sustainability', content: 'As you enter the Sustainability phase, our <strong>24/7 support</strong> and continuous <strong>DevSecOps</strong> integration guarantee long-term reliability and scalability.', icon: journey4},
  ];

  const [progress, setProgress] = useState(0);
  const [currentStage, setCurrentStage] = useState(stages[0]);
  const activeStage = Math.floor(progress / 25);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        const newProgress = prevProgress >= 100 ? 0 : prevProgress + 0.5;
        // Dynamically update the stage based on progress
        if (newProgress >= 0 && newProgress < 25) {
          setCurrentStage(stages[0]);
        } else if (newProgress >= 25 && newProgress < 50) {
          setCurrentStage(stages[1]);
        } else if (newProgress >= 50 && newProgress < 75) {
          setCurrentStage(stages[2]);
        } else if (newProgress >= 75 && newProgress <= 100) {
          setCurrentStage(stages[3]);
        }
        return newProgress;
      });
    }, 100); // Change this value to adjust the speed

    return () => {
      clearInterval(timer);
    };
  }, []);


  //vertical tabs
  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ position: "relative" }}>{children}</Box>}
      </div>
    )
  }

  function a11yProps(index: number) {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    }
  }

  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  const [activeTab, setActiveTab] = React.useState(0)

  const handleTabChange = (
    event: any,
    newTab: React.SetStateAction<number>
  ) => {
    setActiveTab(newTab)
  }

  const [currentQuestion, setCurrentQuestion] = useState("firstquestion")

  const handleAnswer = () => {
    if (currentQuestion === "firstquestion") {
      setCurrentQuestion("secondquestion")
    } else if (currentQuestion === "secondquestion") {
      setCurrentQuestion("thirdquestion")
    } else if (currentQuestion === "thirdquestion") {
      window.location.href = "/ai-llm-business-transformation/"
    } else {
    }
  }

  useEffect(() => {
    const defaultCard = document.getElementById("scmCard")
    if (defaultCard) {
      defaultCard.classList.add("industryCardDesktophover")
    }
  }, [])

  const handleCardHover = (id: any) => {
    const hoveredCard = document.getElementById(id)
    if (hoveredCard) {
      hoveredCard.classList.add("industryCardDesktophover")
    }
  }

  const handleCardLeave = (id: any) => {
    const hoveredCard = document.getElementById(id)
    if (hoveredCard) {
      hoveredCard.classList.remove("industryCardDesktophover")
    }
  }

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const openContactDialog = () => {
    setIsDialogOpen(true);
    setShowSuccessMessage(false); 
    setShowErrorMessage(false);
  };
  const closeContactDialog = () => setIsDialogOpen(false)
  const handleSuccessMsg = () => {
    setShowSuccessMessage(true);
  };
  const handleErrorMsg = () => {
    setShowErrorMessage(true);
  };

  const [isPromoDialogOpen, setIsPromoDialogOpen] = React.useState(false);
  const openPromoContactDialog = () => {
    setIsPromoDialogOpen(true);
  };
  const closePromoContactDialog = () => setIsPromoDialogOpen(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      openPromoContactDialog();
    }, 40000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <Layout topPromotab={true}>
      <Seo
        title="Invimatic | Secure SaaS Development, Continuous Compliance & Product Engineering"
        description="Invimatic – Secure SaaS Enabler with Continuous Compliance & Product Engineering | Build scalable SaaS products with robust security & seamless compliance"
        keywords="Product Engineering Services"
        previewImage={InvimaticLogo}
      />
      <ContactDialog
        open={isDialogOpen}
        handleClose={closeContactDialog}
        onSubmitSuccess={handleSuccessMsg}
        onSubmitError={handleErrorMsg}
        showSuccessMessage={showSuccessMessage}
        showErrorMessage={showErrorMessage}
        isPromoDialog={false}
        isPromoFormDialog={false}
      ></ContactDialog>
      <ContactDialog
        open={isPromoDialogOpen}
        handleClose={closePromoContactDialog}
        link="/blog/soc-2-compliance-checklist-saas/"
        isPromoDialog={true}
        isPromoFormDialog={false}
      ></ContactDialog>
      <div className="fullpage">
        <section className="newheroSection">
          <Swiper
            className="mySwiper homepage-banner-swiper"
            modules={[Autoplay, Pagination, Navigation]}
            // spaceBetween={24}
            // slidesPerView={1.25}
            loop={true}
            // centeredSlides={true}
            autoplay={{ delay: 3000 }}
            pagination={{
              clickable: true,
            }}
          >
            <SwiperSlide style={{ height: isMobile ? "400px" : "100%" }}>
              <Box>
                <img
                  src={isMobile ? homepageMobileBanner1 : homepageBanner1}
                  className="img-fluid w-100"
                />
                <Stack
                  gap={3}
                  px={6.5}
                  sx={style.whatWeDoimgOverlay}
                  top={isMobile ? "50%" : "50%"}
                >
                  <Box display="grid" gap={1}>
                    <Typography
                      variant="h5"
                      fontSize={isMobile ? 30 : 52}
                      fontWeight={400}
                      color="#fff"
                    >
                      Secure SaaS Enablement <br /> Through{" "}
                      <strong style={{ color: "#9AE3FF", fontWeight: "600" }}>
                        SOC 2 Compliance
                      </strong>
                    </Typography>
                    {isMobile ? (
                      ""
                    ) : (
                      <Typography
                        variant="body2"
                        fontSize={isMobile ? 16 : 18}
                        color="#fff"
                        width={isMobile ? "100%" : "50%"}
                      >
                        Our SOC 2 compliance solutions safeguard your data and
                        ensure continuous security, helping you build trust and
                        meet compliance needs effortlessly.
                      </Typography>
                    )}
                  </Box>
                  <Button
                    className="btn btn-primary commonBtn"
                    onClick={openContactDialog}
                  >
                    Get Compliant
                    <img
                      src={allImages.whiteArrow}
                      alt="Arrow"
                      className="arrow"
                    />
                  </Button>
                </Stack>
              </Box>
            </SwiperSlide>
            <SwiperSlide style={{ height: isMobile ? "300px" : "100%" }}>
              <Box>
                <img
                  src={isMobile ? homepageMobileBanner2 : homepageBanner2}
                  className="img-fluid w-100"
                />
                <Stack
                  gap={3}
                  px={6.5}
                  sx={style.whatWeDoimgOverlay}
                  top={isMobile ? "64%" : "50%"}
                >
                  <Box display="grid" gap={1}>
                    <Typography
                      variant="h5"
                      fontSize={isMobile ? 30 : 52}
                      fontWeight={400}
                      color="#fff"
                    >
                      Secure SaaS Enablement <br /> Through{" "}
                      <strong style={{ color: "#9AE3FF", fontWeight: "600" }}>
                        Scalable Product Engineering
                      </strong>
                    </Typography>
                    {isMobile ? (
                      ""
                    ) : (
                      <Typography
                        variant="body2"
                        fontSize={isMobile ? 16 : 18}
                        color="#fff"
                        width={isMobile ? "100%" : "50%"}
                      >
                        Invimatic’s product engineering services help you bring
                        your vision to life quickly, with a focus on scalability
                        from day one.
                      </Typography>
                    )}
                  </Box>
                  <Button
                    className="btn btn-primary commonBtn"
                    onClick={openContactDialog}
                  >
                    Scale your SaaS
                    <img
                      src={allImages.whiteArrow}
                      alt="Arrow"
                      className="arrow"
                    />
                  </Button>
                </Stack>
              </Box>
            </SwiperSlide>
            <SwiperSlide style={{ height: isMobile ? "300px" : "100%" }}>
              <Box>
                <img
                  src={isMobile ? homepageMobileBanner3 : homepageBanner3}
                  className="img-fluid w-100"
                />
                <Stack
                  gap={3}
                  px={6.5}
                  sx={style.whatWeDoimgOverlay}
                  top={isMobile ? "64%" : "50%"}
                >
                  <Box display="grid" gap={1}>
                    <Typography
                      variant="h5"
                      fontSize={isMobile ? 30 : 52}
                      fontWeight={400}
                      color="#fff"
                    >
                      Secure SaaS Enablement <br /> Through{" "}
                      <strong style={{ color: "#9AE3FF", fontWeight: "600" }}>
                        On-Demand Staff Augmentation
                      </strong>
                    </Typography>
                    {isMobile ? (
                      ""
                    ) : (
                      <Typography
                        variant="body2"
                        fontSize={isMobile ? 16 : 18}
                        color="#fff"
                        width={isMobile ? "100%" : "50%"}
                      >
                        Invimatic's dynamic staff augmentation services give you
                        the flexibility to scale your team quickly, ensuring the
                        right expertise at every phase of growth.
                      </Typography>
                    )}
                  </Box>
                  <Button
                    className="btn btn-primary commonBtn"
                    onClick={openContactDialog}
                  >
                    Build Your Teams
                    <img
                      src={allImages.whiteArrow}
                      alt="Arrow"
                      className="arrow"
                    />
                  </Button>
                </Stack>
              </Box>
            </SwiperSlide>
          </Swiper>
        </section>

        <section className="logo-slider marqueeSection">
          <Marquee speed={80}>
            <ul>
              <li>
                <img src={airrived} alt="Airrived" />
              </li>
              <li>
                <img src={blabber} alt="blabber" />
              </li>
              <li>
                <img src={bonzai} alt="bonzai" />
              </li>
              <li>
                <img src={maiLabs} alt="Mai-Labs" />
              </li>
              <li>
                <img src={revscale} alt="Revscale" />
              </li>
              <li>
                <img src={RVRPG} alt="RVRPG" />
              </li>
              <li>
                <img src={skillsBridge} alt="Skills Bridge" />
              </li>
              <li>
                <img src={youthPlanning} alt="youthPlanning" />
              </li>
              <li>
                <img src={indialOil} alt="Indian Oil" />
              </li>
              <li>
                <img src={sharedChapter} alt="Shared Chapter" />
              </li>
              <li>
                <img src={loops} alt="loops" />
              </li>
              <li>
                <img src={axolotl} alt="axolotl" />
              </li>
              <li>
                <img src={betterData} alt="betterData" />
              </li>
              <li>
                <img src={chnl} alt="chnl" />
              </li>
              <li>
                <img src={closify} alt="closify" />
              </li>
              <li>
                <img src={cybersentinel} alt="cybersentinel" />
              </li>
              <li>
                <img src={DCID} alt="DCID" />
              </li>
              <li>
                <img src={Demandshore} alt="Demandshore" />
              </li>
              <li>
                <img src={discoInsight} alt="discoInsight" />
              </li>
              <li>
                <img src={elevatyr} alt="elevatyr" />
              </li>
              <li>
                <img src={Infopedia} alt="Infopedia" />
              </li>
              <li>
                <img src={logapps} alt="logapps" />
              </li>
              <li>
                <img src={Maxxton} alt="maxxton" />
              </li>
              <li>
                <img src={mpharma} alt="mpharma" />
              </li>
              <li>
                <img src={Munivisor} alt="Munivisor" />
              </li>
              <li>
                <img src={Peepsride} alt="Peepsride" />
              </li>
              <li>
                <img src={Peoplefy} alt="Peoplefy" />
              </li>
              <li>
                <img src={Redfish} alt="Redfish" />
              </li>
              <li>
                <img src={shufflelab} alt="shufflelab" />
              </li>
              <li>
                <img src={windmill} alt="windmill" />
              </li>
              <li>
                <img src={xtaas} alt="xtaas" />
              </li>
              <li>
                <img src={Yugensys} alt="Yugensys" />
              </li>
              <li>
                <img src={englishExpress} alt="englishExpress" />
              </li>
              <li>
                <img src={nesGlobal} alt="nesGlobal" />
              </li>
              <li>
                <img src={nfsTechnology} alt="nfsTechnology" />
              </li>
              <li>
                <img src={saTechnologies} alt="saTechnologies" />
              </li>
              <li>
                <img src={pulselabs} alt="pulselabs" />
              </li>
              <li>
                <img src={Eveentology} alt="Eveentology" />
              </li>
            </ul>
          </Marquee>
        </section>

        <section className="journey-section">
          <Container maxWidth="lg">
            <Box
              className="journey-block"
              p={isMobile ? "20px" : "50px"}
            >
              <Stack
                alignItems="center"
                sx={style.heading}
                gap={3.5}
                px={{ xs: 0, sm: 0, md: 12.5 }}
              >
                <Stack alignItems="center">
                  <Typography
                    variant="h2"
                    fontSize={42}
                    fontWeight={600}
                    lineHeight={isMobile ? "36px !important" : "50px"}
                    className="sectHeading"
                  >
                    SaaS Enablement for Every Stage <br/> From MVP to Sustainability
                  </Typography>
                </Stack>
              </Stack>

              {/* Stage Indicators */}
              <Grid container spacing={2} sx={{ mb: 3, mt: 3, position: "relative", zIndex : '0' }}>
                {stages.map((stage, index) => (
                  <Grid item key={index} xs={12} sm={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                      <Box
                        sx={{
                          width: 70,
                          height: 70,
                          borderRadius: '50%',
                          marginRight: '12px',
                          backgroundColor: activeStage >= index ? '#226ba5' : '#ccf1ff',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <img
                          src={stage.icon}
                          alt={stage.title}
                          style={{
                            filter: activeStage >= index ? 'invert(1)' : 'unset',
                            height: '40px',
                          }}
                        />
                      </Box>
                      <Typography variant="body1" fontWeight="700" mt={2}>
                        {stage.title}
                      </Typography>
                    </Box>
                  </Grid>
                ))}

                {/* Linear Progress Bar */}
                {isMobile ? "" : <Box sx={{ position: 'absolute', top: '39%', left: '11%', width: '78%', height: '50px', zIndex : '-1'}}>
                  <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                      width: '100%',
                      height: 8,
                      borderRadius: 10,
                      backgroundColor: '#e0e0e0',
                      '& .MuiLinearProgress-bar': {
                        background: 'linear-gradient(90deg, #eb5d41 8.97%, #db4b5b 48.17%, #cd3b72 90.69%)',
                      },
                    }}
                  />
                </Box>}
              </Grid>
              <Box sx={{ mt: 5 }}>
                <Typography variant="body1" className="stage-content" dangerouslySetInnerHTML={{ __html: currentStage.content }}></Typography>
              </Box>
            </Box>
          </Container>
        </section>

        {/* what we do */}
        <section
          className="whatWeDoSect"
          style={{ padding: isMobile ? "20px 0px 10px" : "40px 0px 10px" }}
        >
          <Container maxWidth="lg">
            <Stack sx={{ position: "relative", zIndex: 1, py: 3 }}>
              <Stack
                alignItems="center"
                sx={style.heading}
                gap={3.5}
                px={{ xs: 0, sm: 0, md: 12.5 }}
              >
                <Stack alignItems="center">
                  <Typography
                    variant="h2"
                    fontSize={42}
                    fontWeight={600}
                    className="sectHeading"
                  >
                    What We Do
                  </Typography>
                  <Divider></Divider>
                </Stack>
              </Stack>

              {/* mobile section */}
              {isMobile ? (
                <div className="what-we-do-mobile">
                  <Swiper
                    className="mySwiper solutionSwiper homeWhatWeDoSwiper"
                    modules={[Autoplay, Pagination, Navigation]}
                    spaceBetween={24}
                    slidesPerView={1}
                    loop={true}
                    centeredSlides={true}
                    autoplay={{ delay: 3000 }}
                    pagination={{
                      clickable: false,
                    }}
                    navigation={true}
                  >
                    {whatWeDoMobileData.map((item, index) => (
                      <SwiperSlide>
                        <Box key={index} textAlign="center" padding="0px 5px">
                          <Typography fontSize={20} fontWeight={700} mt={3}>
                            {item.title}
                          </Typography>
                          <Typography
                            fontSize={18}
                            fontWeight={600}
                            mt={1.5}
                            minHeight="3.2rem"
                          >
                            {item.subTitle}
                          </Typography>
                          <Typography fontSize={16} mt={1.5} minHeight="15rem">
                            {item.description}
                          </Typography>
                        </Box>
                        <Stack
                          flexDirection="row"
                          flexWrap="wrap"
                          gap={1}
                          mt={3}
                        >
                          {item.serviceCardData.map((serviceItem, index) => (
                            <Box className="mobileCard" key={index}>
                              <img
                                className="mobileCardImg"
                                src={serviceItem.image}
                                alt={serviceItem.title}
                              />
                              <Box className="mobileOverlay">
                                <Typography fontSize={16}>
                                  {serviceItem.title}
                                </Typography>
                                {serviceItem.url && (
                                  <Button
                                    className="mobileCardButton"
                                    href={serviceItem.url}
                                  >
                                    {serviceItem.buttonName}
                                  </Button>
                                )}
                              </Box>
                            </Box>
                          ))}
                        </Stack>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              ) : (
                <>
                  <Box
                    sx={{
                      ...style.tabBox,
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: 6,
                    }}
                  >
                    <Tabs
                      orientation="vertical"
                      variant="scrollable"
                      value={activeTab}
                      onChange={handleTabChange}
                      aria-label="Vertical tabs"
                    >
                      <Tab
                        label="Product Engineering Services"
                        {...a11yProps(0)}
                      />
                      <Tab label="Marketplace Integrations" {...a11yProps(1)} />
                      <Tab label="Continuous Compliance" {...a11yProps(2)} />
                      <Tab label="DevSecOps and Support" {...a11yProps(3)} />
                    </Tabs>

                    <TabPanel value={activeTab} index={0}>
                      <Box display="grid" gap={2.5}>
                        <Typography variant="h5" fontWeight={600}>
                          Launch with Confidence
                        </Typography>
                        <Typography variant="body1">
                          At the MVP stage, speed and precision are imperative.
                          Invimatic’s product engineering services help you
                          bring your vision to life quickly, with a focus on
                          scalability from day one. Our team collaborates
                          closely with you to validate your product idea, design
                          a robust architecture, and develop a working prototype
                          that not only meets your immediate goals but is
                          designed to scale as your user base grows.
                        </Typography>
                      </Box>
                    </TabPanel>
                    <TabPanel value={activeTab} index={1}>
                      <Box display="grid" gap={2.5}>
                        <Typography variant="h5" fontWeight={600}>
                          Seamless Integrations to Boost Reach
                        </Typography>
                        <Typography variant="body1">
                          When it’s time to scale up and acquire customers,
                          seamless integrations and marketplace plugins are
                          essential. Invimatic helps your SaaS platform
                          integrate with popular third-party tools and services,
                          providing your customers with the flexibility they
                          demand. We enable smooth connectivity with other
                          systems and offer custom plugins to help you expand
                          your product’s reach, ensuring that your platform fits
                          effortlessly into your customers' existing workflows.
                        </Typography>
                      </Box>
                    </TabPanel>
                    <TabPanel value={activeTab} index={2}>
                      <Box display="grid" gap={2.5}>
                        <Typography variant="h5" fontWeight={600}>
                          Protect Your Growth with Security and Compliance
                        </Typography>
                        <Typography variant="body1">
                          As your platform grows, customer retention becomes a
                          top priority,security is paramount. Invimatic provides
                          advanced security solutions, including continuous
                          compliance services such as SOC 2. We ensure your SaaS
                          platform remains compliant with the latest security
                          standards, building trust with your customers and
                          protecting your business from vulnerabilities.
                          Invimatic incorporates security at every step, and
                          helps you safeguard your growth and strengthen
                          customer loyalty.
                        </Typography>
                      </Box>
                    </TabPanel>
                    <TabPanel value={activeTab} index={3}>
                      <Box display="grid" gap={2.5}>
                        <Typography variant="h5" fontWeight={600}>
                          Long-Term Stability and Support
                        </Typography>
                        <Typography variant="body1">
                          Sustainability is the key to long-term SaaS success.
                          Invimatic offers comprehensive DevSecOps services,
                          integrating security seamlessly into your development
                          and operations processes. Our 24/7 support services
                          ensure your platform runs smoothly at all times,
                          giving you peace of mind. Whether it’s maintaining
                          uptime, addressing technical issues, or continuously
                          improving your infrastructure, we’re here to help you
                          build a sustainable, future-proof SaaS product.
                        </Typography>
                      </Box>
                    </TabPanel>
                  </Box>

                  {activeTab === 0 && (
                    <Grid
                      container
                      className="what-we-do-services"
                      spacing={2}
                      mt={3}
                    >
                      {whatWeDoServiceCardData.map((card, index) => (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={card.gridWidth}
                          key={index}
                          onMouseEnter={() => setHoveredIndex(index)}
                          onMouseLeave={() => setHoveredIndex(null)}
                        >
                          <ImageCard
                            itemIndex={index}
                            buttonType={card.buttonType}
                            image={card.image}
                            title={card.title}
                            description={card.description}
                            url={card.url}
                            isHovered={hoveredIndex === index}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  )}

                  {activeTab === 1 && (
                    <Grid
                      container
                      className="what-we-do-services"
                      spacing={2}
                      mt={3}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        onMouseEnter={() => setHoveredIndex(0)}
                        onMouseLeave={() => setHoveredIndex(null)}
                      >
                        <ImageCard
                          itemIndex={0}
                          buttonType="page"
                          image={marketIntegration1}
                          title="Marketplace Integrations"
                          description="Invimatic helps SaaS companies scale by building custom marketplace applications and seamless integrations, placing your product on platforms like AWS and Salesforce AppExchange, and ensuring greater visibility, customer acquisition, and market penetration across digital ecosystems."
                          url="/saas-integration-platform/"
                          isHovered={hoveredIndex === 0}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={6}>
                        <Grid container spacing={2}>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            onMouseEnter={() => setHoveredIndex(1)}
                            onMouseLeave={() => setHoveredIndex(null)}
                          >
                            <ImageCard
                              itemIndex={0}
                              buttonType="casestudy"
                              image={marketIntegration2}
                              title="Streamlining Data - Salesforce and HubSpot Integration"
                              description=""
                              url="/streamlining-data-salesforce/"
                              isHovered={hoveredIndex === 1}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            onMouseEnter={() => setHoveredIndex(2)}
                            onMouseLeave={() => setHoveredIndex(null)}
                          >
                            <ImageCard
                              itemIndex={0}
                              buttonType="blog"
                              image={marketIntegration3}
                              title="Third Party integrations to enrich your app development!"
                              description=""
                              url="/blog/integration/third-party-integrations-to-enrich-your-app-development/"
                              isHovered={hoveredIndex === 2}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={12} lg={6}>
                        <img
                          src={testimonial1}
                          alt="Marketplace Integrations"
                          width="100%"
                        />
                        <Box position="absolute" top="24%" left="8%">
                          <Typography fontSize={18} color="#000">
                            "Invimatic Solutions is a great partner for development needs. Their skilled team provides cost-effective solutions and meaningful support for complex projects."
                          </Typography>
                          <Stack
                            className="what-we-do-profile"
                            flexDirection="row"
                            alignItems="center"
                            mt={5}
                          >
                            <img
                              src={Will}
                              alt="Will Marling"
                              width="10%"
                              className="rounded-circle"
                            />
                            <Box ml="30px">
                              <Typography
                                color="#000"
                                fontSize="18px"
                                fontWeight="700"
                              >
                                Will Marling
                              </Typography>
                              <Typography color="#000" fontSize="12px">
                                COO and VP for SE Implementation Services, ShuffleLabs
                              </Typography>
                            </Box>
                          </Stack>
                        </Box>
                      </Grid>
                    </Grid>
                  )}

                  {activeTab === 2 && (
                    <Grid
                      container
                      className="what-we-do-services"
                      spacing={2}
                      mt={3}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        onMouseEnter={() => setHoveredIndex(0)}
                        onMouseLeave={() => setHoveredIndex(null)}
                      >
                        <ImageCard
                          itemIndex={0}
                          buttonType="page"
                          image={continuousCompliance1}
                          title="Continuous Compliance"
                          description="Safeguard your SaaS platform with Invimatic’s continuous compliance services like SOC 2, ensuring security and regulatory adherence while building customer trust and protecting your business from evolving threats."
                          url="/soc-2-compliance-saas-solutions/"
                          isHovered={hoveredIndex === 0}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={6}>
                        <Grid container spacing={2}>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            onMouseEnter={() => setHoveredIndex(1)}
                            onMouseLeave={() => setHoveredIndex(null)}
                          >
                            <ImageCard
                              itemIndex={0}
                              buttonType="casestudy"
                              image={continuousCompliance2}
                              title="SOC 2 Compliance for a Leading SaaS Company"
                              description=""
                              url="/soc-2-compliance-saas-provider/"
                              isHovered={hoveredIndex === 1}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            onMouseEnter={() => setHoveredIndex(2)}
                            onMouseLeave={() => setHoveredIndex(null)}
                          >
                            <ImageCard
                              itemIndex={0}
                              buttonType="blog"
                              image={continuousCompliance3}
                              title="SaaS applications on Soc2 compliance"
                              description=""
                              url="/saas-applications-on-soc2-compliance/"
                              isHovered={hoveredIndex === 2}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={12} lg={6}>
                        <img
                          src={testimonial1}
                          alt="Marketplace Integrations"
                          width="100%"
                        />
                        <Box position="absolute" top="19%" left="8%">
                          <Typography fontSize={18} color="#000">
                            "Working with Invimatic's team, led by Raghava and Prashant, was a privilege. They exceeded our expectations with their expertise and timely delivery."
                          </Typography>
                          <Stack
                            className="what-we-do-profile"
                            flexDirection="row"
                            alignItems="center"
                            mt={5}
                          >
                            <img
                              src={cleve}
                              alt="Clive Vaz"
                              width="10%"
                              className="rounded-circle"
                            />
                            <Box ml="30px">
                              <Typography
                                color="#000"
                                fontSize="18px"
                                fontWeight="700"
                              >
                                Clive Vaz
                              </Typography>
                              <Typography color="#000" fontSize="12px">
                                Technology consulting & advisory, PeepsRide
                              </Typography>
                            </Box>
                          </Stack>
                        </Box>
                      </Grid>
                    </Grid>
                  )}

                  {activeTab === 3 && (
                    <Grid
                      container
                      className="what-we-do-services"
                      spacing={2}
                      mt={3}
                    >
                      {whatWeDoDevsecopsCardData.map((card, index) => (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={card.gridWidth}
                          key={index}
                          onMouseEnter={() => setHoveredIndex(index)}
                          onMouseLeave={() => setHoveredIndex(null)}
                        >
                          <ImageCard
                            itemIndex={index}
                            buttonType={card.buttonType}
                            image={card.image}
                            title={card.title}
                            description={card.description}
                            url={card.url}
                            isHovered={hoveredIndex === index}
                          />
                        </Grid>
                      ))}
                      <Grid item xs={12} sm={12} lg={4}>
                        <img
                          src={testimonial2Bg}
                          alt="Marketplace Integrations"
                          width="100%"
                          style={{borderRadius: "10px"}}
                        />
                        <Box position="absolute" top="12%" left="8%">
                          <Typography fontSize={18} color="#000">
                            "Invimatic was crucial to our startup's success. They delivered high-quality work on tight deadlines and kept us informed with clear communication."
                          </Typography>
                          <Stack
                            className="what-we-do-profile"
                            flexDirection="row"
                            alignItems="center"
                            mt={4}
                          >
                            <img
                              src={aaron}
                              alt="Aaron Dix"
                              width="13%"
                              className="rounded-circle"
                            />
                            <Box ml="30px">
                              <Typography
                                color="#000"
                                fontSize="18px"
                                fontWeight="700"
                              >
                                Aaron Dix
                              </Typography>
                              <Typography color="#000" fontSize="12px">
                                Founder & CEO, BettrData.io
                              </Typography>
                            </Box>
                          </Stack>
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                </>
              )}
            </Stack>
          </Container>
        </section>

        <section
          className="banner-section"
          style={{ padding: isMobile ? "20px 0px 40px" : "10px 0px 70px" }}
        >
          <Container maxWidth="lg">
            {isMobile ? (
              <Box>
                <Stack
                  sx={{
                    backgroundColor: "rgb(204 241 255)",
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "10px",
                    padding: "15px 30px 30px",
                  }}
                >
                  <Typography
                    fontSize="30px"
                    fontWeight="700"
                    textAlign="center"
                  >
                    Staff Augmentation
                  </Typography>
                  <Typography fontSize={18} mt={2} mb={2} textAlign="center">
                    Bridge talent gaps effortlessly with Invimatic's on-demand
                    staff augmentation services, offering pre-vetted elite
                    professionals from top institutes to scale your SaaS
                    projects swiftly and securely while reducing operational
                    costs
                  </Typography>
                  <Button
                    variant="outlined"
                    href="/it-staff-augmentation-services-saas/"
                    sx={{
                      borderRadius: "50px",
                      border: "1px solid #256aa3",
                      color: "#256aa3",
                      padding: "6px 15px",
                      fontWeight: "bold",
                      '&:hover': {
                        color: "#256aa3",
                      }
                    }}
                  >
                    Know More &nbsp;&nbsp;<ArrowOutwardIcon />
                  </Button>
                </Stack>
              </Box>
            ) : (
              <Box position="relative">
                <img
                  src={staffAugmentationHomeBanner}
                  alt="Staff Augmentation"
                  width="100%"
                  style={{borderRadius: "15px"}}
                />
                <Stack position="absolute" top="9%" right="2%" width="51%">
                  <Typography fontSize="30px" fontWeight="700">
                    Staff Augmentation
                  </Typography>
                  <Stack
                    flexDirection="row"
                    alignItems="flex-start"
                    justifyContent="space-between"
                    mt={1.5}
                  >
                    <Typography fontSize={14} width="70%">
                      Bridge talent gaps effortlessly with Invimatic's on-demand
                      staff augmentation services, offering pre-vetted elite
                      professionals from top institutes to scale your SaaS
                      projects swiftly and securely while reducing operational
                      costs
                    </Typography>
                    <Button
                      variant="outlined"
                      href="/it-staff-augmentation-services-saas/"
                      sx={{
                        borderRadius: "50px",
                        border: "1px solid #256aa3",
                        color: "#256aa3",
                        padding: "6px 15px",
                        fontWeight: "bold",
                        '&:hover': {
                          color: "#256aa3",
                        }
                      }}
                    >
                      Know More &nbsp;&nbsp;<ArrowOutwardIcon />
                    </Button>
                  </Stack>
                </Stack>
              </Box>
            )}
          </Container>
        </section>

        {/* Industries */}
        <section className="industriesSect">
          <Container maxWidth="lg">
            <Stack gap={6} sx={{ position: "relative", zIndex: 1 }} py={6}>
              <Stack
                alignItems="center"
                sx={style.heading}
                gap={3.5}
                px={{ xs: 0, sm: 0, md: 12.5 }}
              >
                <Stack alignItems="center">
                  <Typography variant="h3" className="sectHeading">
                    Industries
                  </Typography>
                  <Divider></Divider>
                </Stack>
              </Stack>

              {isMobile ? (
                <div className="industryCardmobile">
                  <Swiper
                    className="mySwiper solutionSwiper"
                    modules={[Autoplay, Pagination, Navigation]}
                    spaceBetween={24}
                    slidesPerView={1}
                    autoplay={{
                      delay: 4000,
                    }}
                    pagination={{
                      clickable: false,
                    }}
                  >
                    <SwiperSlide>
                      <Box
                        className="industryCard industryCardMobile scmIndustry"
                        gap={3}
                      >
                        <Stack className="textOverlay scmOverlay">
                          <Typography
                            variant="h4"
                            fontWeight={700}
                            mb={3}
                            pt="0px !important"
                            width="100% !important"
                            color="#fff"
                            className="industryHeading"
                          >
                            Supply Chain Logistics & Manufacturing
                          </Typography>
                          <Stack className="industryDesc" gap={3}>
                            <Typography
                              variant="body2"
                              fontSize={16}
                              color="#fff"
                            >
                              {" "}
                              Streamline operations, enhance efficiency, and
                              drive growth in supply chain, logistics, and
                              manufacturing with custom technology solutions
                              tailored to your business needs.
                            </Typography>
                            <a href="/transforming-logistics-and-inventory-management/">
                              <Button
                                variant="outlined"
                                className="outlineBtn"
                                sx={{
                                  width: "max-content",
                                  textTransform: "capitalize",
                                }}
                              >
                                Know more{" "}
                                <img
                                  src={allImages.whiteArrow}
                                  className="arrow"
                                />
                              </Button>
                            </a>
                          </Stack>
                        </Stack>
                      </Box>
                    </SwiperSlide>
                    <SwiperSlide>
                      <Box className="industryCard industryCardMobile automativeTransportationIndustry">
                        <Stack className="textOverlay automativeTransportationOverlay">
                          <Typography
                            variant="h4"
                            fontWeight={700}
                            mb={3}
                            pt="0px !important"
                            width="100% !important"
                            color="#fff"
                            className="industryHeading"
                          >
                            Automotive & Transportation
                          </Typography>
                          <Stack className="industryDesc" gap={3}>
                            <Typography variant="body1" color="#fff">
                              Achieve your innovation goals with tailored tech
                              solutions that optimize fleet management, automate
                              vehicle dispatch, and improve route planning,
                              allowing you to reduce costs, improve safety, and
                              maximize operational efficiency.
                            </Typography>
                            <a href="/dealer-management-system-software-solutions/">
                              <Button
                                variant="outlined"
                                className="outlineBtn"
                                sx={{
                                  width: "max-content",
                                  textTransform: "capitalize",
                                }}
                              >
                                Know more{" "}
                                <img
                                  src={allImages.whiteArrow}
                                  className="arrow"
                                />
                              </Button>
                            </a>
                          </Stack>
                        </Stack>
                      </Box>
                    </SwiperSlide>
                    <SwiperSlide>
                      <Box className="industryCard industryCardMobile travelHospitalityIndustry">
                        <Stack className="textOverlay travelHospitalityOverlay">
                          <Typography
                            variant="h4"
                            fontWeight={700}
                            mb={3}
                            pt="0px !important"
                            width="100% !important"
                            color="#fff"
                            className="industryHeading"
                          >
                            Travel & Hospitality
                          </Typography>
                          <Stack className="industryDesc" gap={3}>
                            <Typography variant="body1" color="#fff">
                              {" "}
                              Upgrade your customer experiences with
                              custom-engineered platforms designed to simplify
                              bookings, optimise resource allocation, and ensure
                              seamless service delivery, operational efficiency,
                              and customer loyalty.
                            </Typography>
                            <a href="/digital-transformation-in-travel-hospitality/">
                              <Button
                                variant="outlined"
                                className="outlineBtn"
                                sx={{
                                  width: "max-content",
                                  textTransform: "capitalize",
                                }}
                              >
                                Know more{" "}
                                <img
                                  src={allImages.whiteArrow}
                                  className="arrow"
                                />
                              </Button>
                            </a>
                          </Stack>
                        </Stack>
                      </Box>
                    </SwiperSlide>
                    <SwiperSlide>
                      <Box className="industryCard industryCardMobile retailCardIndustry">
                        <Stack className="textOverlay retailOverlay">
                          <Typography
                            variant="h4"
                            fontWeight={700}
                            mb={3}
                            pt="0px !important"
                            width="100% !important"
                            color="#fff"
                            className="industryHeading"
                          >
                            Retail
                          </Typography>
                          <Stack className="industryDesc" gap={3}>
                            <Typography variant="body1" color="#fff">
                              Transform retail operations with customized
                              platforms that streamline inventory management,
                              improve sales tracking, and deliver personalized
                              shopping experiences, improving customer
                              satisfaction and revenue growth.
                            </Typography>
                            <a href="/retail-software-solutions/">
                              <Button
                                variant="outlined"
                                className="outlineBtn"
                                sx={{
                                  width: "max-content",
                                  textTransform: "capitalize",
                                }}
                              >
                                Know more{" "}
                                <img
                                  src={allImages.whiteArrow}
                                  className="arrow"
                                />
                              </Button>
                            </a>
                          </Stack>
                        </Stack>
                      </Box>
                    </SwiperSlide>
                    <SwiperSlide>
                      <Box className="industryCard industryCardMobile hitechIndustry">
                        <Stack className="textOverlay hitechOverlay">
                          <Typography
                            variant="h4"
                            fontWeight={700}
                            mb={3}
                            pt="0px !important"
                            width="100% !important"
                            color="#fff"
                            className="industryHeading"
                          >
                            HiTech
                          </Typography>
                          <Stack className="industryDesc" gap={3}>
                            <Typography variant="body1" color="#fff">
                              Accelerate innovation, enhance performance, and
                              drive digital transformation with advanced
                              technology solutions for the high-tech sector.
                            </Typography>
                            <a href="/high-tech-cloud-security/">
                              <Button
                                variant="outlined"
                                className="outlineBtn"
                                sx={{
                                  width: "max-content",
                                  textTransform: "capitalize",
                                }}
                              >
                                Know more{" "}
                                <img
                                  src={allImages.whiteArrow}
                                  className="arrow"
                                />
                              </Button>
                            </a>
                          </Stack>
                        </Stack>
                      </Box>
                    </SwiperSlide>
                  </Swiper>
                </div>
              ) : (
                <Stack direction="row" justifyContent="center" gap={0.5}>
                  <Box
                    id="scmCard"
                    className="industryCard industryCardDesktop cp"
                    onMouseOver={() => {
                      handleCardHover("scmCard")
                      handleCardLeave("automativeTransportationCard")
                      handleCardLeave("travelHospitalityCard")
                      handleCardLeave("hiTechCard")
                      handleCardLeave("retailCard")
                    }}
                    // onMouseLeave={() => handleCardLeave('scmCard')}
                  >
                    <Stack className="textOverlay scmOverlay">
                      <Typography
                        variant="h4"
                        fontWeight={700}
                        color="#fff"
                        className="industryHeading"
                      >
                        Supply Chain, Logistics and Manufacturing
                      </Typography>
                      <Stack className="industryDesc" gap={4}>
                        <Typography variant="body1" color="#fff">
                          Streamline operations, enhance efficiency, and drive
                          growth in supply chain logistics & manufacturing
                          with custom technology solutions tailored to your
                          business needs.
                        </Typography>
                        <a href="/transforming-logistics-and-inventory-management/">
                          <Button
                            variant="outlined"
                            className="outlineBtn"
                            sx={{
                              width: "max-content",
                              textTransform: "capitalize",
                              "&:hover": {
                                borderColor: "#fff",
                              },
                            }}
                          >
                            Know more{" "}
                            <img
                              src={allImages.whiteArrow}
                              alt="Arrow"
                              className="arrow"
                            />
                          </Button>
                        </a>
                      </Stack>
                    </Stack>
                  </Box>
                  <Box
                    id="automativeTransportationCard"
                    className="industryCard industryCardDesktop cp"
                    onMouseOver={() => {
                      handleCardHover("automativeTransportationCard")
                      handleCardLeave("scmCard")
                      handleCardLeave("travelHospitalityCard")
                      handleCardLeave("hiTechCard")
                      handleCardLeave("retailCard")
                    }}
                    // onMouseLeave={() => handleCardLeave('automativeTransportationCard')}
                  >
                    <Stack className="textOverlay automativeTransportationOverlay">
                      <Typography
                        variant="h4"
                        fontWeight={700}
                        color="#fff"
                        className="industryHeading"
                      >
                        Automotive & Transportation
                      </Typography>
                      <Stack className="industryDesc" gap={4}>
                        <Typography variant="body1" color="#fff">
                          Achieve your innovation goals with tailored tech
                          solutions that optimize fleet management, automate
                          vehicle dispatch, and improve route planning, allowing
                          you to reduce costs, improve safety, and maximize
                          operational efficiency.
                        </Typography>
                        <a href="/dealer-management-system-software-solutions/">
                          <Button
                            variant="outlined"
                            className="outlineBtn"
                            sx={{
                              width: "max-content",
                              textTransform: "capitalize",
                              "&:hover": {
                                borderColor: "#fff",
                              },
                            }}
                          >
                            Know more{" "}
                            <img
                              src={allImages.whiteArrow}
                              alt="Arrow"
                              className="arrow"
                            />
                          </Button>
                        </a>
                      </Stack>
                    </Stack>
                  </Box>
                  <Box
                    id="travelHospitalityCard"
                    className="industryCard industryCardDesktop cp"
                    onMouseOver={() => {
                      handleCardHover("travelHospitalityCard")
                      handleCardLeave("hiTechCard")
                      handleCardLeave("automativeTransportationCard")
                      handleCardLeave("scmCard")
                      handleCardLeave("retailCard")
                    }}
                    // onMouseLeave={() => handleCardLeave('travelHospitalityCard')}
                  >
                    <Stack className="textOverlay travelHospitalityOverlay">
                      <Typography
                        variant="h4"
                        fontWeight={700}
                        color="#fff"
                        className="industryHeading"
                      >
                        Travel & Hospitality
                      </Typography>
                      <Stack className="industryDesc" gap={4}>
                        <Typography variant="body1" color="#fff">
                          Upgrade your customer experiences with
                          custom-engineered platforms designed to simplify
                          bookings, optimise resource allocation, and ensure
                          seamless service delivery, operational efficiency, and
                          customer loyalty.
                        </Typography>
                        <a href="/digital-transformation-in-travel-hospitality/">
                          <Button
                            variant="outlined"
                            className="outlineBtn"
                            sx={{
                              width: "max-content",
                              textTransform: "capitalize",
                              "&:hover": {
                                borderColor: "#fff",
                              },
                            }}
                          >
                            Know more{" "}
                            <img
                              src={allImages.whiteArrow}
                              alt="Arrow"
                              className="arrow"
                            />
                          </Button>
                        </a>
                      </Stack>
                    </Stack>
                  </Box>
                  <Box
                    id="retailCard"
                    className="industryCard industryCardDesktop cp"
                    onMouseOver={() => {
                      handleCardHover("retailCard")
                      handleCardLeave("hiTechCard")
                      handleCardLeave("travelHospitalityCard")
                      handleCardLeave("automativeTransportationCard")
                      handleCardLeave("scmCard")
                    }}
                    sx={{ paddingLeft: "16px !important" }}
                  >
                    <Stack className="textOverlay retailOverlay">
                      <Typography
                        variant="h4"
                        fontWeight={700}
                        color="#fff"
                        className="industryHeading"
                      >
                        Retail
                      </Typography>
                      <Stack className="industryDesc" gap={4}>
                        <Typography variant="body1" color="#fff">
                          Transform retail operations with customized platforms
                          that streamline inventory management, improve sales
                          tracking, and deliver personalized shopping
                          experiences, improving customer satisfaction and
                          revenue growth.
                        </Typography>
                        <a href="/retail-software-solutions/">
                          <Button
                            variant="outlined"
                            className="outlineBtn"
                            sx={{
                              width: "max-content",
                              textTransform: "capitalize",
                              "&:hover": {
                                borderColor: "#fff",
                              },
                            }}
                          >
                            Know more{" "}
                            <img
                              src={allImages.whiteArrow}
                              alt="Arrow"
                              className="arrow"
                            />
                          </Button>
                        </a>
                      </Stack>
                    </Stack>
                  </Box>
                  <Box
                    id="hiTechCard"
                    className="industryCard industryCardDesktop cp"
                    onMouseOver={() => {
                      handleCardHover("hiTechCard")
                      handleCardLeave("travelHospitalityCard")
                      handleCardLeave("automativeTransportationCard")
                      handleCardLeave("scmCard")
                      handleCardLeave("retailCard")
                    }}
                    // onMouseLeave={() => handleCardLeave('hiTechCard')}
                  >
                    <Stack className="textOverlay hitechOverlay">
                      <Typography
                        variant="h4"
                        fontWeight={700}
                        color="#fff"
                        className="industryHeading"
                      >
                        HiTech
                      </Typography>
                      <Stack className="industryDesc" gap={4}>
                        <Typography variant="body1" color="#fff">
                          Accelerate innovation, enhance performance, and drive
                          digital transformation with advanced technology
                          solutions for the high-tech sector.
                        </Typography>
                        <a href="/high-tech-cloud-security/">
                          <Button
                            variant="outlined"
                            className="outlineBtn"
                            sx={{
                              width: "max-content",
                              textTransform: "capitalize",
                              "&:hover": {
                                borderColor: "#fff",
                              },
                            }}
                          >
                            Know more{" "}
                            <img
                              src={allImages.whiteArrow}
                              alt="Arrow"
                              className="arrow"
                            />
                          </Button>
                        </a>
                      </Stack>
                    </Stack>
                  </Box>
                </Stack>
              )}
            </Stack>
          </Container>
        </section>

        {/* Who we are section */}
        <section className="whoWeAreSect">
          <Container maxWidth="lg">
            <Stack gap={6} sx={{ position: "relative", zIndex: 1 }} py={6}>
              {isMobile ? (
                <></>
              ) : (
                <Stack
                  alignItems="center"
                  sx={style.heading}
                  gap={3.5}
                  px={{ xs: 0, sm: 0, md: 12.5 }}
                >
                  <Stack alignItems="center">
                    <Typography variant="h4" className="sectHeading">
                      Who We Are
                    </Typography>
                    <Divider></Divider>
                    <Typography variant="body1" textAlign="center" mt={2}>
                      We are a team of developers and innovators driven by our
                      passion for technology. Technology should be used to
                      empower people, not overwhelm them. That’s why we focus on
                      providing our clients with the best possible solutions.
                    </Typography>
                  </Stack>
                </Stack>
              )}
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  flexDirection: isMobile ? "column" : "row",
                }}
              >
                <Stack direction="column">
                  <Stack direction="row">
                    {isMobile ? (
                      <Typography
                        variant="h6"
                        fontSize={32}
                        fontWeight={400}
                        lineHeight="normal"
                      >
                        Invimatic At a Glance
                      </Typography>
                    ) : (
                      <Typography
                        variant="h6"
                        fontSize={42}
                        fontWeight={400}
                        lineHeight="normal"
                      >
                        Invimatic <br /> At a Glance
                      </Typography>
                    )}
                  </Stack>
                  {isMobile ? (
                    <Stack direction="row" alignItems="center">
                      <img
                        src={planeIconMob}
                        alt="Plane icon"
                        style={{ width: "100%" }}
                      />
                    </Stack>
                  ) : (
                    <Stack direction="row" alignItems="center">
                      <img src={planeLine} alt="Plane icon" />
                      <img src={planeIcon} alt="Plane icon" />
                    </Stack>
                  )}

                  {isMobile ? (
                    <Typography
                      variant="h6"
                      fontSize={16}
                      fontWeight={400}
                      mt={2.5}
                    >
                      Empowering 
                      <span
                        style={{
                          color: "#256aa3",
                          fontWeight: "700",
                          fontStyle: "italic",
                        }}
                      >{" "}Innovation{" "}</span> 
                      Through
                      <span
                        style={{
                          color: "#256aa3",
                          fontWeight: "700",
                          fontStyle: "italic",
                        }}
                      >
                        {" "}
                        Empathy{" "}
                      </span>{" "}
                      And By
                      <span
                        style={{
                          color: "#256aa3",
                          fontWeight: "700",
                          fontStyle: "italic",
                        }}
                      >
                        {" "}
                        Speaking Your Domain Language
                      </span>{" "}
                      - To Help You Achieve Your Goals
                    </Typography>
                  ) : (
                    <Typography
                      variant="h6"
                      fontSize={16}
                      fontWeight={400}
                      mt={2.5}
                    >
                      Empowering 
                      <span
                        style={{
                          color: "#256aa3",
                          fontWeight: "700",
                          fontStyle: "italic",
                        }}
                      >{" "}Innovation{" "}</span> 
                      Through
                      <span
                        style={{
                          color: "#256aa3",
                          fontWeight: "700",
                          fontStyle: "italic",
                        }}
                      >
                        {" "}
                        Empathy{" "}
                      </span>{" "}
                      <br />
                      And By
                      <span
                        style={{
                          color: "#256aa3",
                          fontWeight: "700",
                          fontStyle: "italic",
                        }}
                      >
                        {" "}
                        Speaking Your Domain Language
                      </span>
                      <br />- To Help You Achieve Your Goals
                    </Typography>
                  )}
                </Stack>
                <Stack direction="column" alignItems="center">
                  <img
                    src={invistat1}
                    className="img-fluid invimaticStatsImg"
                  />
                </Stack>
              </Box>
            </Stack>
          </Container>
        </section>

        {/* feature */}
        <section>
          <Container maxWidth="lg">
            <Stack direction="row" justifyContent="center" pt={1} pb={isMobile ? "40px" : "50px"}>
              <img src={semicircleimageDark} className="img-fluid" width="75%" alt="five-principle-of-invimatic" />
            </Stack>
          </Container>
        </section>

        {/* TO DO enable this if want question and answer section */}
        {/* question  answer section */}
        {/* {isMobile ? (
          <section className="questionMobSect">
            <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
              <Box
                display="flex"
                alignItems="flex-start"
                gap={6}
                pt={4}
                pb={2.5}
                flexDirection="column"
              >
                <Stack>
                  <Typography
                    variant="h4"
                    fontSize={26}
                    fontWeight={700}
                    color="#fff"
                  >
                    Answer a Few Questions <br />
                    <Typography
                      variant="h4"
                      fontSize={26}
                      fontWeight={700}
                      color="#63BBFF"
                    >
                      To Unlock Insights Into AI/LLM
                    </Typography>
                  </Typography>
                </Stack>
                <Stack
                  id="firstquestion"
                  alignItems="center"
                  style={{
                    display:
                      currentQuestion === "firstquestion" ? "flex" : "none",
                    width: "100%",
                  }}
                  gap={6}
                >
                  <Stack alignItems="center" gap="14px">
                    <Typography
                      variant="body1"
                      color="#8BCCFF"
                      fontSize={14}
                      fontWeight={600}
                    >
                      <span
                        style={{
                          fontSize: "20px",
                          fontWeight: 600,
                          color: "#fff",
                        }}
                      >
                        1
                      </span>{" "}
                      of 3 questions
                    </Typography>
                    <Typography
                      variant="h5"
                      fontSize={22}
                      fontWeight={500}
                      color="#fff"
                      textAlign="center"
                      sx={{ px: 2.5 }}
                    >
                      Are you utilizing AI/LLM to enhance your competitive edge?
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    width="100%"
                    mt={2.5}
                  >
                    <Button
                      onClick={handleAnswer}
                      variant="contained"
                      startIcon={<NorthWestIcon />}
                      sx={{
                        background: "#00ACAC",
                        borderRadius: 12,
                        textTransform: "capitalize",
                      }}
                    >
                      Yes
                    </Button>
                    <Button
                      onClick={handleAnswer}
                      variant="contained"
                      endIcon={<NorthEastIcon />}
                      sx={{
                        background: "#FF5D5D",
                        borderRadius: 12,
                        textTransform: "capitalize",
                      }}
                    >
                      No
                    </Button>
                  </Stack>
                </Stack>

                <Stack
                  id="secondquestion"
                  alignItems="center"
                  style={{
                    display:
                      currentQuestion === "secondquestion" ? "flex" : "none",
                    width: "100%",
                  }}
                  gap={6}
                >
                  <Stack alignItems="center" gap="14px">
                    <Typography
                      variant="body1"
                      color="#8BCCFF"
                      fontSize={14}
                      fontWeight={600}
                    >
                      <span
                        style={{
                          fontSize: "20px",
                          fontWeight: 600,
                          color: "#fff",
                        }}
                      >
                        2
                      </span>{" "}
                      of 3 questions
                    </Typography>
                    <Typography
                      variant="h5"
                      fontSize={22}
                      fontWeight={500}
                      color="#fff"
                      textAlign="center"
                    >
                      What will AI/LLM investments unlock for you?
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    width="100%"
                    mt={2.5}
                  >
                    <Button
                      onClick={handleAnswer}
                      variant="contained"
                      startIcon={<NorthWestIcon />}
                      sx={{
                        background: "#00ACAC",
                        borderRadius: 12,
                        textTransform: "capitalize",
                      }}
                    >
                      Better CX
                    </Button>
                    <Button
                      onClick={handleAnswer}
                      variant="contained"
                      endIcon={<NorthEastIcon />}
                      sx={{
                        background: "#FF5D5D",
                        borderRadius: 12,
                        textTransform: "capitalize",
                      }}
                    >
                      Smarter Predictions
                    </Button>
                  </Stack>
                </Stack>

                <Stack
                  id="thirdquestion"
                  alignItems="center"
                  style={{
                    display:
                      currentQuestion === "thirdquestion" ? "flex" : "none",
                    width: "100%",
                  }}
                  gap={6}
                >
                  <Stack alignItems="center" gap="14px">
                    <Typography
                      variant="body1"
                      color="#8BCCFF"
                      fontSize={14}
                      fontWeight={600}
                    >
                      <span
                        style={{
                          fontSize: "20px",
                          fontWeight: 600,
                          color: "#fff",
                        }}
                      >
                        3
                      </span>{" "}
                      of 3 questions
                    </Typography>
                    <Typography
                      variant="h5"
                      fontSize={22}
                      fontWeight={500}
                      color="#fff"
                      textAlign="center"
                    >
                      What challenges limit AI/LLM-fueled advancement?
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    width="100%"
                    mt={2.5}
                  >
                    <Button
                      onClick={handleAnswer}
                      variant="contained"
                      startIcon={<NorthWestIcon />}
                      sx={{
                        background: "#00ACAC",
                        borderRadius: 12,
                        textTransform: "capitalize",
                      }}
                    >
                      Cost
                    </Button>
                    <Button
                      onClick={handleAnswer}
                      variant="contained"
                      endIcon={<NorthEastIcon />}
                      sx={{
                        background: "#FF5D5D",
                        borderRadius: 12,
                        textTransform: "capitalize",
                      }}
                    >
                      Complexity
                    </Button>
                  </Stack>
                </Stack>
              </Box>
            </Container>
          </section>
        ) : (
          <section className="questionSect">
            <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
              <Box display="flex" alignItems="center" py={12.5} gap={10}>
                <Stack gap={7}>
                  <Typography
                    variant="h4"
                    fontSize={42}
                    fontWeight={700}
                    color="#fff"
                  >
                    Answer a Few Questions <br />
                    <Typography
                      variant="h4"
                      fontSize={42}
                      fontWeight={700}
                      color="#63BBFF"
                    >
                      To Unlock Insights <br /> Into AI/LLM
                    </Typography>
                  </Typography>
                </Stack>
                <Stack
                  id="firstquestion"
                  style={{
                    display:
                      currentQuestion === "firstquestion" ? "block" : "none",
                  }}
                >
                  <Typography variant="body1" color="#8BCCFF">
                    <span
                      style={{
                        fontSize: "24px",
                        fontWeight: 400,
                        color: "#fff",
                      }}
                    >
                      1
                    </span>{" "}
                    of 3 questions
                  </Typography>
                  <Box
                    sx={{
                      position: "relative",
                      borderRadius: "10px",
                      overflow: "hidden",
                    }}
                  >
                    <img src={integration} alt="Integration" />
                    <Stack
                      gap={10}
                      sx={{ ...style.imgOverlay, py: 2, px: 2.5 }}
                    >
                      <Typography
                        variant="h5"
                        fontWeight={700}
                        color="#fff"
                        textAlign="center"
                      >
                        Are you utilizing AI/LLM to enhance your competitive
                        edge?
                      </Typography>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        sx={{
                          borderTop: "1px solid rgba(255, 255, 255, 0.40)",
                          pt: 1.5,
                        }}
                      >
                        <Button
                          onClick={handleAnswer}
                          variant="contained"
                          startIcon={<NorthWestIcon />}
                          sx={{
                            background: "#00ACAC",
                            borderRadius: 12,
                            textTransform: "capitalize",
                          }}
                        >
                          Yes
                        </Button>
                        <Button
                          onClick={handleAnswer}
                          variant="contained"
                          endIcon={<NorthEastIcon />}
                          sx={{
                            background: "#FF5D5D",
                            borderRadius: 12,
                            textTransform: "capitalize",
                          }}
                        >
                          No
                        </Button>
                      </Stack>
                    </Stack>
                  </Box>
                </Stack>
                <Stack
                  id="secondquestion"
                  style={{
                    display:
                      currentQuestion === "secondquestion" ? "block" : "none",
                  }}
                >
                  <Typography variant="body1" color="#8BCCFF">
                    <span
                      style={{
                        fontSize: "24px",
                        fontWeight: 400,
                        color: "#fff",
                      }}
                    >
                      2
                    </span>{" "}
                    of 3 questions
                  </Typography>
                  <Box
                    sx={{
                      position: "relative",
                      borderRadius: "10px",
                      overflow: "hidden",
                    }}
                  >
                    <img src={integration} alt="Integration" />
                    <Stack
                      gap={10}
                      sx={{ ...style.imgOverlay, py: 2, px: 2.5 }}
                    >
                      <Typography
                        variant="h5"
                        fontWeight={700}
                        color="#fff"
                        textAlign="center"
                      >
                        What will AI/LLM investments unlock for you?
                      </Typography>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        sx={{
                          borderTop: "1px solid rgba(255, 255, 255, 0.40)",
                          pt: 1.5,
                        }}
                      >
                        <Button
                          onClick={handleAnswer}
                          variant="contained"
                          startIcon={<NorthWestIcon />}
                          sx={{
                            background: "#00ACAC",
                            borderRadius: 12,
                            textTransform: "capitalize",
                          }}
                        >
                          Better CX
                        </Button>
                        <Button
                          onClick={handleAnswer}
                          variant="contained"
                          endIcon={<NorthEastIcon />}
                          sx={{
                            background: "#FF5D5D",
                            borderRadius: 12,
                            textTransform: "capitalize",
                          }}
                        >
                          Smarter Predictions
                        </Button>
                      </Stack>
                    </Stack>
                  </Box>
                </Stack>
                <Stack
                  id="thirdquestion"
                  style={{
                    display:
                      currentQuestion === "thirdquestion" ? "block" : "none",
                  }}
                >
                  <Typography variant="body1" color="#8BCCFF">
                    <span
                      style={{
                        fontSize: "24px",
                        fontWeight: 400,
                        color: "#fff",
                      }}
                    >
                      3
                    </span>{" "}
                    of 3 questions
                  </Typography>
                  <Box
                    sx={{
                      position: "relative",
                      borderRadius: "10px",
                      overflow: "hidden",
                    }}
                  >
                    <img src={integration} alt="Integration" />
                    <Stack
                      gap={10}
                      sx={{ ...style.imgOverlay, py: 2, px: 2.5 }}
                    >
                      <Typography
                        variant="h5"
                        fontWeight={700}
                        color="#fff"
                        textAlign="center"
                      >
                        What challenges limit AI/LLM-fueled advancement?
                      </Typography>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        sx={{
                          borderTop: "1px solid rgba(255, 255, 255, 0.40)",
                          pt: 1.5,
                        }}
                      >
                        <Button
                          onClick={handleAnswer}
                          variant="contained"
                          startIcon={<NorthWestIcon />}
                          sx={{
                            background: "#00ACAC",
                            borderRadius: 12,
                            textTransform: "capitalize",
                          }}
                        >
                          Cost
                        </Button>
                        <Button
                          onClick={handleAnswer}
                          variant="contained"
                          endIcon={<NorthEastIcon />}
                          sx={{
                            background: "#FF5D5D",
                            borderRadius: 12,
                            textTransform: "capitalize",
                          }}
                        >
                          Complexity
                        </Button>
                      </Stack>
                    </Stack>
                  </Box>
                </Stack>
              </Box>
            </Container>
          </section>
        )} */}

        {/* TO DO: this section is saas bundle and cohuman solution AI RPA section */}
        {/* <section className="cardBox">
          <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
            <Grid container py={12.5} spacing={5}>
              <Grid item xs={12} sm={12} lg={6} sx={{position: 'relative'}}>
                <Stack alignItems="center" mb="40px" sx={{minHeight: isMobile ? "unset" : "11rem"}}>
                  <Typography variant="h3" className="sectHeading" color="#ffffff" textAlign="center" lineHeight={isMobile ? "34px !important" : "50px"}>
                    Transition into a Smarter Future with Co-Human: Your AI+RPA Partner
                  </Typography>
                  <Divider sx={{width: "64px", height:"4px", background: "#DC4C5A", marginTop: "8px"}}></Divider>
                </Stack>
                <Card className="cardBoxBlock1">
                  <Box sx={style.cardboxInner} 
                    onMouseOver={()=>setCardHover1(true)} 
                    onMouseLeave={()=>setCardHover1(false)}
                    style={{borderBottom: cardHover1 ? '2px solid #14f1f5': "unset"}}
                  >
                    <Typography
                      variant="h4"
                      fontSize={18}
                      fontWeight={700}
                      textAlign="center"
                      color="#14F1F5"
                    >
                      Co-Human is Your <span style={{color: "#ffffff"}}>AI + RPA Partner</span> for a Smarter Future of Work
                      { cardHover1 ? <div style={{fontSize: "14px", color: "#ffffff", marginTop: "20px", lineHeight: "22px", fontWeight: 500}}>Free your team from repetitive tasks and unleash new potential with Co-Human. Our AI + RPA solution automates processes, enhances customer interactions intelligently, and unlocks a new era of operational efficiency.</div>: "" }
                  </Typography>
                  <a href="/cohuman-solution/" style={{display: "flex", justifyContent: "center", marginTop: "20px"}}>
                    <Button
                      variant="outlined"
                      sx={style.cardButton}
                    >
                      Know more{" "}
                      <img
                        src={allImages.whiteArrow}
                        className="arrow"
                      />
                    </Button>
                  </a>
                  </Box>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} lg={6} sx={{position: 'relative'}}>
                <Stack alignItems="center" mb="40px" sx={{minHeight: isMobile ? "unset" : "11rem"}}>
                  <Typography variant="h3" className="sectHeading" color="#ffffff" textAlign="center" lineHeight={isMobile ? "34px !important" : "50px"}>
                    Accelerate Your Success with Customizable SaaS Bundles
                  </Typography>
                  <Divider sx={{width: "64px", height:"4px", background: "#DC4C5A", marginTop: "8px"}}></Divider>
                </Stack>
                <Card className="cardBoxBlock2">
                  <Box sx={style.cardboxInner} 
                    onMouseOver={()=>setCardHover2(true)} 
                    onMouseLeave={()=>setCardHover2(false)}
                    style={{borderBottom: cardHover2 ? '2px solid #14f1f5': "unset"}}
                  >
                    <Typography
                       variant="h4"
                       fontSize={18}
                       fontWeight={700}
                       textAlign="center"
                       color="#14F1F5"
                    >
                      Wanted Effortless Growth for Your SaaS Business? Get <span style={{color: "#ffffff"}}>Customizable SaaS Bundles</span> Now!
                      { cardHover2 ? <div style={{fontSize: "14px", color: "#ffffff", marginTop: "20px", lineHeight: "22px", fontWeight: 500}}>Invimatic's custom SaaS bundles provide the essential tools and expertise you need. DevSecOps to streamline operations, SSO to optimize user experience, and achieve secured growth with Integrations.</div>: "" }
                    </Typography>
                    <a href="/saas-bundle-offerings/" style={{display: "flex", justifyContent: "center", marginTop: "20px"}}>
                      <Button
                        variant="outlined"
                        sx={style.cardButton}
                      >
                        Know more{" "}
                        <img
                          src={allImages.whiteArrow}
                          className="arrow"
                        />
                      </Button>
                    </a>
                  </Box>
                </Card>
              </Grid>
            </Grid>
          </Container>
        </section> */}

        {/* success story */}
        <div className="successStoryCarousel">
          <section className="successStory">
            <Stack
              alignItems="center"
              sx={style.heading}
              pb={6}
              px={{ xs: 0, sm: 0, md: 12.5 }}
            >
              <Typography color="rgb(255, 255, 255)" className="sectHeading">
                Our Success Stories
              </Typography>
              <Divider></Divider>
            </Stack>
            <Box className="successStoryBox">
              <Swiper
                // className="mySwiper solutionSwiper"
                className="mySwiper swiper-container desktopView "
                modules={[Autoplay, Pagination, Navigation]}
                // spaceBetween={100}
                slidesPerView={1}
                // loop={true}
                centeredSlides={true}
                autoplay={{ delay: 6000 }}
                // pagination={{
                //   clickable: true,
                // }}
                navigation={true}
              >
                <SwiperSlide className="slideWidth h-100">
                  <Box
                    sx={{ position: "relative" }}
                    id="successStory1"
                    className="successStorySlide"
                  >
                    {isMobile ? (
                      <img
                        src={theloops}
                        style={{
                          width: "100%",
                          height: 670,
                          objectFit: "cover",
                        }}
                        className="img-fluid"
                      />
                    ) : (
                      <img
                        src={theloops}
                        className="img-fluid"
                        style={{
                          width: "100%",
                          height: 570,
                          objectFit: "cover",
                        }}
                      />
                    )}
                    <Stack
                      className="whiteCard"
                      sx={{ width: "100%", px: 5.5, py: 4, borderRadius: 2 }}
                    >
                      <Box
                        className="whiteBg"
                        display="flex"
                        gap={2}
                        flexDirection="column"
                      >
                        <Box display="grid" gap={2.5}>
                          <Stack>
                            <Typography
                              variant="body1"
                              fontSize={18}
                              fontWeight={800}
                              color="#333"
                            >
                              Challenge:
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              lineHeight="24px"
                            >
                              Dive on a journey through 'TheLoops' success
                              story, where the implementation prowess of
                              Invimatic accelerates processes, boosts
                              efficiency, and significantly reduces average
                              handling time for customer experience teams.
                            </Typography>
                          </Stack>
                          <Stack>
                            <Typography
                              variant="body1"
                              fontSize={18}
                              fontWeight={800}
                              color="#333"
                            >
                              Solutions:
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              lineHeight="24px"
                            >
                              Leverage NLP to understand customer inquiries and
                              provide accurate recommendations.
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              lineHeight="24px"
                            >
                              Implement automated responses and chatbots for
                              faster resolution of simple queries.
                            </Typography>
                          </Stack>
                          <Divider
                            variant="middle"
                            component="li"
                            sx={{
                              background: "#00000014",
                              width: "100%",
                              m: 0,
                            }}
                          />
                          <Grid container justifyContent="space-between">
                            <Grid item xs={3} sm={2} md={3} lg={3}>
                              <Typography
                                variant="h4"
                                fontSize={32}
                                fontWeight={800}
                                color="#E97826"
                              >
                                15%
                              </Typography>
                              <Typography
                                variant="body1"
                                fontSize={isMobile ? 14 : 16}
                                fontWeight={500}
                                color="#333"
                                lineHeight="24px"
                              >
                                Increased Agent Productivity
                              </Typography>
                            </Grid>
                            <Divider
                              orientation="vertical"
                              variant="middle"
                              flexItem
                              sx={{
                                background: "#00000014",
                                width: "1px",
                                m: 0,
                                height: "100%",
                              }}
                            />
                            <Grid item xs={3} sm={2} md={3} lg={3}>
                              <Typography
                                variant="h4"
                                fontSize={32}
                                fontWeight={800}
                                color="#218524"
                              >
                                20%
                              </Typography>
                              <Typography
                                variant="body2"
                                fontSize={isMobile ? 14 : 16}
                                fontWeight={500}
                                color="#333"
                              >
                                Reduced Customer Wait Times
                              </Typography>
                            </Grid>
                            <Divider
                              orientation="vertical"
                              variant="middle"
                              flexItem
                              sx={{
                                background: "#00000014",
                                width: "1px",
                                m: 0,
                                height: "100%",
                              }}
                            />
                            <Grid item xs={3} sm={2} md={3} lg={4}>
                              <Typography
                                variant="h4"
                                fontSize={32}
                                fontWeight={800}
                                color="#6A49EB"
                              >
                                10%
                              </Typography>
                              <Typography
                                variant="body2"
                                fontSize={isMobile ? 14 : 16}
                                fontWeight={500}
                                color="#333"
                              >
                                Increased First Contact Resolution Rate
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    </Stack>
                  </Box>
                </SwiperSlide>
                <SwiperSlide className="slideWidth h-100">
                  <Box
                    sx={{ position: "relative" }}
                    id="successStory2"
                    className="successStorySlide"
                  >
                    {isMobile ? (
                      <img
                        src={klarity}
                        style={{
                          width: "100%",
                          height: 670,
                          objectFit: "cover",
                        }}
                        className="img-fluid"
                      />
                    ) : (
                      <img
                        src={klarity}
                        className="img-fluid"
                        style={{
                          width: "100%",
                          height: 570,
                          objectFit: "cover",
                        }}
                      />
                    )}

                    <Stack
                      className="whiteCard"
                      sx={{ width: "100%", px: 5.5, py: 4, borderRadius: 2 }}
                    >
                      <Box
                        className="whiteBg"
                        display="flex"
                        gap={2}
                        flexDirection="column"
                      >
                        <Box display="grid" gap={2.5}>
                          <Stack>
                            <Typography
                              variant="body1"
                              fontSize={18}
                              fontWeight={800}
                              color="#333"
                            >
                              Challenge:
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              lineHeight="24px"
                            >
                              Explore the success of 'Klarity Software', which
                              uses customer-centric solutions.{" "}
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              lineHeight="24px"
                            >
                              The skill of LLM seamlessly eliminates pointless
                              calls and messages to create a streamlined and
                              effective interaction.
                            </Typography>
                          </Stack>
                          <Stack>
                            <Typography
                              variant="body1"
                              fontSize={18}
                              fontWeight={800}
                              color="#333"
                            >
                              Solutions:
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              lineHeight="24px"
                            >
                              Create an AI-driven knowledge base for precise
                              product query responses.
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              lineHeight="24px"
                            >
                              Equip your team with a dedicated app, giving
                              instant access to customer info, account details,
                              and data-driven insights for effective follow-ups.
                            </Typography>
                          </Stack>

                          <Divider
                            variant="middle"
                            component="li"
                            sx={{
                              background: "#00000014",
                              width: "100%",
                              m: 0,
                            }}
                          />

                          <Grid container justifyContent="space-between">
                            <Grid item xs={4} sm={2} md={3} lg={4}>
                              <Typography
                                variant="h4"
                                fontSize={32}
                                fontWeight={800}
                                color="#E97826"
                              >
                                30%
                              </Typography>
                              <Typography
                                variant="body2"
                                fontSize={isMobile ? 14 : 16}
                                fontWeight={500}
                                color="#333"
                                lineHeight="24px"
                              >
                                Reduced Unnecessary Communication
                              </Typography>
                            </Grid>
                            <Divider
                              orientation="vertical"
                              variant="middle"
                              flexItem
                              sx={{
                                background: "#00000014",
                                width: "1px",
                                m: 0,
                                height: "100%",
                              }}
                            />
                            <Grid item xs={3} sm={2} md={3} lg={3}>
                              <Typography
                                variant="h4"
                                fontSize={32}
                                fontWeight={800}
                                color="#218524"
                              >
                                15%
                              </Typography>
                              <Typography
                                variant="body2"
                                fontSize={isMobile ? 14 : 16}
                                fontWeight={500}
                                color="#333"
                              >
                                Increased Buyer Satisfaction
                              </Typography>
                            </Grid>
                            <Divider
                              orientation="vertical"
                              variant="middle"
                              flexItem
                              sx={{
                                background: "#00000014",
                                width: "1px",
                                m: 0,
                                height: "100%",
                              }}
                            />
                            <Grid item xs={3} sm={2} md={3} lg={3}>
                              <Typography
                                variant="h4"
                                fontSize={32}
                                fontWeight={800}
                                color="#6A49EB"
                              >
                                10%
                              </Typography>
                              <Typography
                                variant="body2"
                                fontSize={isMobile ? 14 : 16}
                                fontWeight={500}
                                color="#333"
                              >
                                Boost in Sales
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    </Stack>
                  </Box>
                </SwiperSlide>
                <SwiperSlide className="slideWidth h-100">
                  <Box
                    sx={{ position: "relative" }}
                    id="successStory3"
                    className="successStorySlide"
                  >
                    {isMobile ? (
                      <img
                        src={shuffleLabs}
                        style={{
                          width: "100%",
                          height: 670,
                          objectFit: "cover",
                        }}
                        className="img-fluid"
                      />
                    ) : (
                      <img
                        src={shuffleLabs}
                        className="img-fluid"
                        style={{
                          width: "100%",
                          height: 570,
                          objectFit: "cover",
                        }}
                      />
                    )}
                    <Stack
                      className="whiteCard"
                      sx={{ width: "100%", px: 5.5, py: 4, borderRadius: 2 }}
                    >
                      <Box
                        className="whiteBg"
                        display="flex"
                        gap={2}
                        flexDirection="column"
                      >
                        <Box display="grid" gap={2.5}>
                          <Stack>
                            <Typography
                              variant="body1"
                              fontSize={18}
                              fontWeight={800}
                              color="#333"
                            >
                              Challenge:
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              lineHeight="24px"
                            >
                              Discover how 'ShuffleLabs' conquered intricate
                              deployment challenges, evolving from a cumbersome
                              individual application setup to streamlined server
                              management and enhanced scalability.
                            </Typography>
                          </Stack>
                          <Stack>
                            <Typography
                              variant="body1"
                              fontSize={18}
                              fontWeight={800}
                              color="#333"
                            >
                              Solutions:
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              lineHeight="24px"
                            >
                              Migrate to Kubernetes to automate deployments,
                              eliminate manual intervention, and guarantee
                              consistent tenant versions.
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              lineHeight="24px"
                            >
                              Implement automated pipelines and SSL certificate
                              management to streamline operations and reduce
                              administrative overhead.
                            </Typography>
                          </Stack>
                          <Divider
                            variant="middle"
                            component="li"
                            sx={{
                              background: "#00000014",
                              width: "100%",
                              m: 0,
                            }}
                          />

                          <Grid container>
                            <Grid item xs={4} sm={2} md={4} lg={5}>
                              <Typography
                                variant="h4"
                                fontSize={32}
                                fontWeight={800}
                                color="#E97826"
                              >
                                20%{" "}
                              </Typography>
                              <Typography
                                variant="body2"
                                fontSize={isMobile ? 14 : 16}
                                fontWeight={500}
                                color="#333"
                              >
                                Reduced Operational Costs
                              </Typography>
                            </Grid>
                            <Divider
                              orientation="vertical"
                              variant="middle"
                              flexItem
                              sx={{
                                background: "#00000014",
                                width: "1px",
                                mr: 3,
                                ml: 0,
                                height: "100%",
                              }}
                            />
                            <Grid item xs={4} sm={2} md={4} lg={5}>
                              <Typography
                                variant="h4"
                                fontSize={32}
                                fontWeight={800}
                                color="#218524"
                              >
                                99.9%
                              </Typography>
                              <Typography
                                variant="body2"
                                fontWeight={500}
                                lineHeight="24px"
                              >
                                {" "}
                                Improved Service Availability
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    </Stack>
                  </Box>
                </SwiperSlide>
              </Swiper>
            </Box>
          </section>
        </div>

        {/* Case Studies */}
        <section className="caseStudiesSect">
          <Container maxWidth="lg">
            <Stack
              gap={6}
              sx={{ position: "relative", zIndex: 1 }}
              pb={6}
              pt={6}
            >
              <Stack
                alignItems="center"
                sx={style.heading}
                gap={3.5}
                px={{ xs: 0, sm: 0, md: 12.5 }}
              >
                <Stack alignItems="center">
                  <Typography
                    variant="h3"
                    color="rgb(255, 255, 255)"
                    className="sectHeading"
                  >
                    Case Studies
                  </Typography>
                  <Divider></Divider>
                </Stack>
              </Stack>
            </Stack>

            {isMobile ? (
              <Grid container sx={{ position: "relative" }}>
                <Swiper
                  className="mySwiper swiper-container desktopView"
                  modules={[Autoplay, Pagination, Navigation]}
                  spaceBetween={100}
                  slidesPerView={1}
                  loop={true}
                  centeredSlides={true}
                  autoplay={{ delay: 3000 }}
                  pagination={{
                    clickable: true,
                  }}
                >
                  <SwiperSlide>
                    <Grid item xs={12} sm={6} md={4}>
                      <a href="/rpa-marketing/">
                        <Card sx={{ borderRadius: 2.5 }}>
                          <CardActionArea>
                            <CardMedia
                              component="img"
                              height="140"
                              image={casecard1}
                              alt="Cryptocurrency"
                              sx={{ objectPosition: "top", objectFit: "fill" }}
                            />
                            <CardContent sx={{ textAlign: "center" }}>
                              {/* <Chip label="RPA" sx={{ ...style.chipLabel, backgroundColor: '#DDFDDE' }} /> */}
                              <Typography
                                gutterBottom
                                variant="h5"
                                fontSize={18}
                                fontWeight={700}
                                mb={0}
                                color="#333"
                                component="div"
                              >
                                An Industry leading marketing agency evolution
                                from Generic Marketing to Personalized Journeys
                              </Typography>
                            </CardContent>
                            <CardActions
                              sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                            >
                              <Button
                                size="small"
                                sx={{
                                  textDecoration: "underline",
                                  textTransform: "Unset",
                                  fontWeight: "700",
                                }}
                              >
                                Read more
                                <img src={arrowRight} alt="Arrow icon" />
                              </Button>
                            </CardActions>
                          </CardActionArea>
                        </Card>
                      </a>
                    </Grid>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Grid item xs={12} sm={6} md={4}>
                      <a href="/ai-email-behavior-analysis/">
                        <Card sx={{ borderRadius: 2.5 }}>
                          <CardActionArea>
                            <CardMedia
                              component="img"
                              height="140"
                              image={casecard2}
                              alt="Airportalertsystem"
                              sx={{ objectPosition: "top", objectFit: "fill" }}
                            />
                            <CardContent sx={{ textAlign: "center" }}>
                              {/* <Chip label="MarTech" sx={{ ...style.chipLabel, backgroundColor: '#FDE3A3', border: '1px solid #DAA00C' }} /> */}
                              <Typography
                                gutterBottom
                                variant="h5"
                                fontSize="18px"
                                fontWeight={700}
                                mb={0}
                                color="#333"
                                component="div"
                              >
                                Behavioral Automation for SaaS Company
                              </Typography>
                            </CardContent>
                            <CardActions
                              sx={{ justifyContent: "center", pt: 6, pb: 1.5 }}
                            >
                              <Button
                                size="small"
                                sx={{
                                  textDecoration: "underline",
                                  textTransform: "Unset",
                                  fontWeight: "700",
                                }}
                              >
                                Read more
                                <img src={arrowRight} alt="Arrow icon" />
                              </Button>
                            </CardActions>
                          </CardActionArea>
                        </Card>
                      </a>
                    </Grid>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Grid item xs={12} sm={6} md={4}>
                      <a href="/health-pharma-drug-lifecycle/">
                        <Card sx={{ borderRadius: 2.5 }}>
                          <CardActionArea>
                            <CardMedia
                              component="img"
                              height="140"
                              image={casecard3}
                              alt="Uservalidation"
                              sx={{ objectPosition: "top", objectFit: "fill" }}
                            />
                            <CardContent sx={{ textAlign: "center" }}>
                            {/* <Chip label="HealthTech" sx={{ ...style.chipLabel, backgroundColor: '#FDE3A3', border: '1px solid #DAA00C' }} /> */}
                              <Typography
                                gutterBottom
                                variant="h5"
                                fontSize="18px"
                                fontWeight={700}
                                color="#333"
                                mb={0}
                                component="div"
                              >
                                Pharma Solution for Drug Lifecycle Management
                              </Typography>
                            </CardContent>
                            <CardActions
                              sx={{ justifyContent: "center", pt: 3, pb: 1.5 }}
                            >
                              <Button
                                size="small"
                                sx={{
                                  textDecoration: "underline",
                                  textTransform: "Unset",
                                  fontWeight: "700",
                                }}
                              >
                                Read more
                                <img src={arrowRight} alt="Arrow icon" />
                              </Button>
                            </CardActions>
                          </CardActionArea>
                        </Card>
                      </a>
                    </Grid>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Grid item xs={12} sm={6} md={4}>
                      <a href="/streamlining-logistics-operations-through-integrated-warehouse-management-system/">
                        <Card sx={{ borderRadius: 2.5 }}>
                          <CardActionArea>
                            <CardMedia
                              component="img"
                              height="140"
                              image={casecard4}
                              alt="Cryptocurrency"
                              sx={{ objectPosition: "top", objectFit: "fill" }}
                            />
                            <CardContent sx={{ textAlign: "center" }}>
                              <Typography
                                gutterBottom
                                variant="h5"
                                fontSize={18}
                                fontWeight={700}
                                mb={0}
                                color="#333"
                                component="div"
                              >
                                Streamlining Logistics Operations through
                                Integrated Warehouse Management System
                              </Typography>
                            </CardContent>
                            <CardActions
                              sx={{ justifyContent: "center", pt: 3, pb: 1.5 }}
                            >
                              <Button
                                size="small"
                                sx={{
                                  textDecoration: "underline",
                                  textTransform: "Unset",
                                  fontWeight: "700",
                                }}
                              >
                                Read more
                                <img src={arrowRight} alt="Arrow icon" />
                              </Button>
                            </CardActions>
                          </CardActionArea>
                        </Card>
                      </a>
                    </Grid>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Grid item xs={12} sm={6} md={4}>
                      <a href="/building-resilient-infrastructure-for-seamless-customer-service-delivery/">
                        <Card sx={{ borderRadius: 2.5 }}>
                          <CardActionArea>
                            <CardMedia
                              component="img"
                              height="140"
                              image={casecard5}
                              alt="Airportalertsystem"
                              sx={{ objectPosition: "top", objectFit: "fill" }}
                            />
                            <CardContent sx={{ textAlign: "center" }}>
                              <Typography
                                gutterBottom
                                variant="h5"
                                fontSize="18px"
                                fontWeight={700}
                                mb={0}
                                color="#333"
                                component="div"
                              >
                                Building Resilient Infrastructure for Seamless
                                Customer Service Delivery
                              </Typography>
                            </CardContent>
                            <CardActions
                              sx={{ justifyContent: "center", pt: 3, pb: 1.5 }}
                            >
                              <Button
                                size="small"
                                sx={{
                                  textDecoration: "underline",
                                  textTransform: "Unset",
                                  fontWeight: "700",
                                }}
                              >
                                Read more
                                <img src={arrowRight} alt="Arrow icon" />
                              </Button>
                            </CardActions>
                          </CardActionArea>
                        </Card>
                      </a>
                    </Grid>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Grid item xs={12} sm={6} md={4}>
                      <a href="/streamlining-operations-through-integrated-system-management/">
                        <Card sx={{ borderRadius: 2.5 }}>
                          <CardActionArea>
                            <CardMedia
                              component="img"
                              height="140"
                              image={casecard6}
                              alt="Uservalidation"
                              sx={{ objectPosition: "top", objectFit: "fill" }}
                            />
                            <CardContent sx={{ textAlign: "center" }}>
                              <Typography
                                gutterBottom
                                variant="h5"
                                fontSize="18px"
                                fontWeight={700}
                                color="#333"
                                mb={0}
                                component="div"
                              >
                                Streamlining Operations through Integrated
                                System Management
                              </Typography>
                            </CardContent>
                            <CardActions
                              sx={{ justifyContent: "center", pt: 3, pb: 1.5 }}
                            >
                              <Button
                                size="small"
                                sx={{
                                  textDecoration: "underline",
                                  textTransform: "Unset",
                                  fontWeight: "700",
                                }}
                              >
                                Read more
                                <img src={arrowRight} alt="Arrow icon" />
                              </Button>
                            </CardActions>
                          </CardActionArea>
                        </Card>
                      </a>
                    </Grid>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Grid item xs={12} sm={6} md={4}>
                      <a href="/english-express-llm-chatbot/">
                        <Card sx={{ borderRadius: 2.5 }}>
                          <CardActionArea>
                            <CardMedia
                              component="img"
                              height="140"
                              image={casecard7}
                              alt="Uservalidation"
                              sx={{ objectPosition: "top", objectFit: "fill" }}
                            />
                            <CardContent sx={{ textAlign: "center" }}>
                              <Typography
                                gutterBottom
                                variant="h5"
                                fontSize="18px"
                                fontWeight={700}
                                color="#333"
                                mb={0}
                                component="div"
                              >
                                Beyond Textbooks: Building an Engaging and
                                Interactive Language Learning Experience with
                                English Express
                              </Typography>
                            </CardContent>
                            <CardActions
                              sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                            >
                              <Button
                                size="small"
                                sx={{
                                  textDecoration: "underline",
                                  textTransform: "Unset",
                                  fontWeight: "700",
                                }}
                              >
                                Read more
                                <img src={arrowRight} alt="Arrow icon" />
                              </Button>
                            </CardActions>
                          </CardActionArea>
                        </Card>
                      </a>
                    </Grid>
                  </SwiperSlide>
                </Swiper>
              </Grid>
            ) : (
              <Swiper
                className="mySwiper swiper-container desktopView"
                modules={[Autoplay, Pagination, Navigation]}
                spaceBetween={14}
                loop={true}
                centeredSlides={true}
                autoplay={{ delay: 3000 }}
                navigation={true}
              >
                <SwiperSlide className="homepage-casestudy-slide">
                  <Box 
                    display="flex"
                    flexDirection="row"
                    mx="auto"
                    gap={3}
                  >
                    <Card sx={{ borderRadius: 2.5 }}>
                      <CardActionArea href="/rpa-marketing/">
                        <CardMedia
                          component="img"
                          height="140"
                          image={casecard1}
                          alt="Cryptocurrency"
                          sx={{ objectPosition: "top", objectFit: "fill" }}
                        />
                        <CardContent sx={{ textAlign: "center" }}>
                          <Typography
                            gutterBottom
                            variant="h5"
                            fontSize={17}
                            fontWeight={700}
                            mb={0}
                            color="#333"
                            component="div"
                          >
                            An Industry leading marketing agency evolution
                            from Generic Marketing to Personalized Journeys
                          </Typography>
                        </CardContent>
                        <CardActions
                          sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                        >
                          <Button
                            size="small"
                            sx={{
                              textDecoration: "underline",
                              textTransform: "Unset",
                              fontWeight: "700",
                            }}
                          >
                            Read more
                            <img src={arrowRight} alt="Arrow icon" />
                          </Button>
                        </CardActions>
                      </CardActionArea>
                    </Card>
                    <Card sx={{ borderRadius: 2.5 }}>
                      <CardActionArea href="/ai-email-behavior-analysis/"> 
                        <CardMedia
                          component="img"
                          height="140"
                          image={casecard2}
                          alt="Airportalertsystem"
                          sx={{ objectPosition: "top", objectFit: "fill" }}
                        />
                        <CardContent sx={{ textAlign: "center" }}>
                          <Typography
                            gutterBottom
                            variant="h5"
                            fontSize="17px"
                            fontWeight={700}
                            mb={0}
                            color="#333"
                            component="div"
                          >
                            Behavioral Automation for SaaS Company
                          </Typography>
                        </CardContent>
                        <CardActions
                          sx={{ justifyContent: "center", pt: 3, pb: 1.5 }}
                        >
                          <Button
                            size="small"
                            sx={{
                              textDecoration: "underline",
                              textTransform: "Unset",
                              fontWeight: "700",
                            }}
                          >
                            Read more
                            <img src={arrowRight} alt="Arrow icon" />
                          </Button>
                        </CardActions>
                      </CardActionArea>
                    </Card>
                    <Card sx={{ borderRadius: 2.5 }}>
                      <CardActionArea href="/health-pharma-drug-lifecycle/">
                        <CardMedia
                          component="img"
                          height="140"
                          image={casecard3}
                          alt="Uservalidation"
                          sx={{ objectPosition: "top", objectFit: "fill" }}
                        />
                        <CardContent sx={{ textAlign: "center" }}>
                          <Typography
                            gutterBottom
                            variant="h5"
                            fontSize="17px"
                            fontWeight={700}
                            color="#333"
                            mb={0}
                            component="div"
                          >
                            Pharma Solution for Drug Lifecycle Management
                          </Typography>
                        </CardContent>
                        <CardActions
                          sx={{ justifyContent: "center", pt: 3, pb: 1.5 }}
                        >
                          <Button
                            size="small"
                            sx={{
                              textDecoration: "underline",
                              textTransform: "Unset",
                              fontWeight: "700",
                            }}
                          >
                            Read more
                            <img src={arrowRight} alt="Arrow icon" />
                          </Button>
                        </CardActions>
                      </CardActionArea>
                    </Card>
                  </Box>
                </SwiperSlide>
                <SwiperSlide className="homepage-casestudy-slide">
                  <Box
                    display="flex"
                    flexDirection="row"
                    mx="auto"
                    gap={3}
                  >
                    <Card sx={{ borderRadius: 2.5 }}>
                      <CardActionArea href="/streamlining-logistics-operations-through-integrated-warehouse-management-system/">
                        <CardMedia
                          component="img"
                          height="140"
                          image={casecard4}
                          alt="Cryptocurrency"
                          sx={{ objectPosition: "top", objectFit: "fill" }}
                        />
                        <CardContent sx={{ textAlign: "center" }}>
                          <Typography
                            gutterBottom
                            variant="h5"
                            fontSize={17}
                            fontWeight={700}
                            mb={0}
                            color="#333"
                            component="div"
                          >
                            Streamlining Logistics Operations through
                            Integrated Warehouse Management System
                          </Typography>
                        </CardContent>
                        <CardActions
                          sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                        >
                          <Button
                            size="small"
                            sx={{
                              textDecoration: "underline",
                              textTransform: "Unset",
                              fontWeight: "700",
                            }}
                          >
                            Read more
                            <img src={arrowRight} alt="Arrow icon" />
                          </Button>
                        </CardActions>
                      </CardActionArea>
                    </Card>
                    <Card sx={{ borderRadius: 2.5 }}>
                      <CardActionArea href="/building-resilient-infrastructure-for-seamless-customer-service-delivery/">
                        <CardMedia
                          component="img"
                          height="140"
                          image={casecard5}
                          alt="Airportalertsystem"
                          sx={{ objectPosition: "top", objectFit: "fill" }}
                        />
                        <CardContent sx={{ textAlign: "center" }}>
                          <Typography
                            gutterBottom
                            variant="h5"
                            fontSize="17px"
                            fontWeight={700}
                            mb={0}
                            color="#333"
                            component="div"
                          >
                            Building Resilient Infrastructure for Seamless
                            Customer Service Delivery
                          </Typography>
                        </CardContent>
                        <CardActions
                          sx={{ justifyContent: "center", pt: 3, pb: 1.5 }}
                        >
                          <Button
                            size="small"
                            sx={{
                              textDecoration: "underline",
                              textTransform: "Unset",
                              fontWeight: "700",
                            }}
                          >
                            Read more
                            <img src={arrowRight} alt="Arrow icon" />
                          </Button>
                        </CardActions>
                      </CardActionArea>
                    </Card>
                    <Card sx={{ borderRadius: 2.5 }}>
                      <CardActionArea href="/streamlining-operations-through-integrated-system-management/">
                        <CardMedia
                          component="img"
                          height="140"
                          image={casecard6}
                          alt="Uservalidation"
                          sx={{ objectPosition: "top", objectFit: "fill" }}
                        />
                        <CardContent sx={{ textAlign: "center" }}>
                          <Typography
                            gutterBottom
                            variant="h5"
                            fontSize="17px"
                            fontWeight={700}
                            color="#333"
                            mb={0}
                            component="div"
                          >
                            Streamlining Operations through Integrated
                            System Management
                          </Typography>
                        </CardContent>
                        <CardActions
                          sx={{ justifyContent: "center", pt: 3, pb: 1.5 }}
                        >
                          <Button
                            size="small"
                            sx={{
                              textDecoration: "underline",
                              textTransform: "Unset",
                              fontWeight: "700",
                            }}
                          >
                            Read more
                            <img src={arrowRight} alt="Arrow icon" />
                          </Button>
                        </CardActions>
                      </CardActionArea>
                    </Card>
                  </Box>
                </SwiperSlide>
                <SwiperSlide className="homepage-casestudy-slide">
                  <Box
                    display="flex"
                    flexDirection="row"
                    mx="auto"
                    gap={3}
                  >
                    <Card sx={{ borderRadius: 2.5 }}>
                      <CardActionArea href="/english-express-llm-chatbot/">
                        <CardMedia
                          component="img"
                          height="140"
                          image={casecard7}
                          alt="Uservalidation"
                          sx={{ objectPosition: "top", objectFit: "fill" }}
                        />
                        <CardContent sx={{ textAlign: "center" }}>
                          <Typography
                            gutterBottom
                            variant="h5"
                            fontSize="17px"
                            fontWeight={700}
                            color="#333"
                            mb={0}
                            component="div"
                          >
                            Beyond Textbooks: Building an Engaging and
                            Interactive Language Learning Experience with
                            English Express
                          </Typography>
                        </CardContent>
                        <CardActions
                          sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                        >
                          <Button
                            size="small"
                            sx={{
                              textDecoration: "underline",
                              textTransform: "Unset",
                              fontWeight: "700",
                            }}
                          >
                            Read more
                            <img src={arrowRight} alt="Arrow icon" />
                          </Button>
                        </CardActions>
                      </CardActionArea>
                    </Card>
                    <Card sx={{ borderRadius: 2.5 }}>
                      <CardActionArea href="/rpa-marketing/">
                        <CardMedia
                          component="img"
                          height="140"
                          image={casecard1}
                          alt="Cryptocurrency"
                          sx={{ objectPosition: "top", objectFit: "fill" }}
                        />
                        <CardContent sx={{ textAlign: "center" }}>
                          <Typography
                            gutterBottom
                            variant="h5"
                            fontSize={17}
                            fontWeight={700}
                            mb={0}
                            color="#333"
                            component="div"
                          >
                            An Industry leading marketing agency evolution
                            from Generic Marketing to Personalized Journeys
                          </Typography>
                        </CardContent>
                        <CardActions
                          sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                        >
                          <Button
                            size="small"
                            sx={{
                              textDecoration: "underline",
                              textTransform: "Unset",
                              fontWeight: "700",
                            }}
                          >
                            Read more
                            <img src={arrowRight} alt="Arrow icon" />
                          </Button>
                        </CardActions>
                      </CardActionArea>
                    </Card>
                    <Card sx={{ borderRadius: 2.5 }}>
                      <CardActionArea href="/ai-email-behavior-analysis/">
                        <CardMedia
                          component="img"
                          height="140"
                          image={casecard2}
                          alt="Airportalertsystem"
                          sx={{ objectPosition: "top", objectFit: "fill" }}
                        />
                        <CardContent sx={{ textAlign: "center" }}>
                          <Typography
                            gutterBottom
                            variant="h5"
                            fontSize="17px"
                            fontWeight={700}
                            mb={0}
                            color="#333"
                            component="div"
                          >
                            Behavioral Automation for SaaS Company
                          </Typography>
                        </CardContent>
                        <CardActions
                          sx={{ justifyContent: "center", pt: 3, pb: 1.5 }}
                        >
                          <Button
                            size="small"
                            sx={{
                              textDecoration: "underline",
                              textTransform: "Unset",
                              fontWeight: "700",
                            }}
                          >
                            Read more
                            <img src={arrowRight} alt="Arrow icon" />
                          </Button>
                        </CardActions>
                      </CardActionArea>
                    </Card>
                  </Box>
                </SwiperSlide>
              </Swiper>
            )}
            <Stack alignItems="center">
              <Button
                variant="outlined"
                href="/case-studiesdata/"
                sx={{
                  borderRadius: "50px",
                  border: "1px solid #fff",
                  color: "#fff",
                  padding: "6px 15px",
                  margin: isMobile ? "40px 0px 0px" : "40px 0px 60px",
                  fontWeight: "bold",
                  '&:hover': {
                    color: "#fff",
                    border: "1px solid #fff", 
                  }
                }}
              >
                View All &nbsp;&nbsp;<ArrowOutwardIcon />
              </Button>
            </Stack>
          </Container>
        </section>

        {/* Testimonial section */}
        <section className="customerSect">
          <Testimonial />
        </section>

        <section className="discussYourProject">
          <Container maxWidth="lg">
            <Stack
              sx={{
                position: "relative",
                zIndex: 1,
                pt: isMobile ? 0 : 5,
                pb: 0,
              }}
              direction={isMobile ? "column" : "row"}
              alignItems="center"
            >
              <Stack
                alignItems="center"
                gap={6}
                sx={{ width: isMobile ? "100%" : "50%" }}
              >
                <Stack alignItems="center" textAlign="center" gap={2}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <img
                      src={chatIcon}
                      alt="Chat"
                      style={{ width: "auto !important" }}
                    />
                  )}
                  <Typography
                    variant="body1"
                    fontSize={isMobile ? 32 : 16}
                    fontWeight={isMobile ? 700 : 600}
                    color={isMobile ? "#fff" : "#C8DCFA"}
                    textAlign="center"
                  >
                    Let's discuss your project
                  </Typography>
                  {isMobile ? (
                    <></>
                  ) : (
                    <Typography
                      variant="h4"
                      color="#fff"
                      fontSize="20px"
                      fontWeight={700}
                      lineHeight="28px"
                      padding="0 30px"
                    >
                      Looking to scale your SaaS effortlessly? <br/>
                      Share your project details, and we'll provide tailored solutions to support the growth and security of your SaaS business.
                    </Typography>
                  )}
                </Stack>
              </Stack>
              <Box
                sx={{
                  width: isMobile ? "100%" : "50%",
                  marginTop: isMobile ? "20px" : "0px",
                }}
              >
                <Enquiry />
              </Box>
            </Stack>
          </Container>
        </section>
      </div>
    </Layout>
  )
}

export default Homepage
